var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/sv-core/sha-storage/medias/media.contracts.ts
var EMediaFolder = /* @__PURE__ */ (function(EMediaFolder2) {
  EMediaFolder2["USER_FACES"] = "USER_FACES";
  EMediaFolder2["AVATARS"] = "AVATARS";
  EMediaFolder2["TEMP"] = "TEMP";
  EMediaFolder2["ACCESS_SNAPSHOTS"] = "ACCESS_SNAPSHOTS";
  EMediaFolder2["USER_IDENTITIES"] = "USER_IDENTITIES";
  return EMediaFolder2;
})({});
var EMediaStatus = /* @__PURE__ */ (function(EMediaStatus2) {
  EMediaStatus2["PENDING"] = "PENDING";
  EMediaStatus2["ACTIVE"] = "ACTIVE";
  EMediaStatus2["DELETED"] = "DELETED";
  EMediaStatus2["ARCHIVED"] = "ARCHIVED";
  return EMediaStatus2;
})({});

// src/sv-core/sha-core/invitations/invitation.contracts.ts
var EInvitationType = /* @__PURE__ */ (function(EInvitationType2) {
  EInvitationType2["FACE_ENROLLMENT"] = "FACE_ENROLLMENT";
  EInvitationType2["ACCOUNT_CREATION"] = "ACCOUNT_CREATION";
  return EInvitationType2;
})({});
var EInvitationStatus = /* @__PURE__ */ (function(EInvitationStatus2) {
  EInvitationStatus2["PENDING"] = "PENDING";
  EInvitationStatus2["USED"] = "USED";
  EInvitationStatus2["EXPIRED"] = "EXPIRED";
  EInvitationStatus2["REVOKED"] = "REVOKED";
  return EInvitationStatus2;
})({});
var IInvitationMetadataEnrollmentType = /* @__PURE__ */ (function(IInvitationMetadataEnrollmentType2) {
  IInvitationMetadataEnrollmentType2["FULL"] = "FULL";
  IInvitationMetadataEnrollmentType2["PARTIAL"] = "PARTIAL";
  return IInvitationMetadataEnrollmentType2;
})({});

// src/sv-core/sha-core/user_faces/user_face.contracts.ts
var EUserFacePosition = /* @__PURE__ */ (function(EUserFacePosition2) {
  EUserFacePosition2["FRONT"] = "FRONT";
  EUserFacePosition2["UP"] = "UP";
  EUserFacePosition2["DOWN"] = "DOWN";
  EUserFacePosition2["LEFT"] = "LEFT";
  EUserFacePosition2["RIGHT"] = "RIGHT";
  return EUserFacePosition2;
})({});
var EUserFaceStatus = /* @__PURE__ */ (function(EUserFaceStatus2) {
  EUserFaceStatus2["PENDING"] = "PENDING";
  EUserFaceStatus2["VALIDATED"] = "VALIDATED";
  EUserFaceStatus2["REJECTED"] = "REJECTED";
  return EUserFaceStatus2;
})({});

// src/sv-core/sha-core/vehicle_memberships/vehicle_membership.contracts.ts
var EVehicleMembershipStateType = /* @__PURE__ */ (function(EVehicleMembershipStateType2) {
  EVehicleMembershipStateType2["ACTIVE"] = "ACTIVE";
  EVehicleMembershipStateType2["PENDING"] = "PENDING";
  EVehicleMembershipStateType2["REJECTED"] = "REJECTED";
  EVehicleMembershipStateType2["BANNED"] = "BANNED";
  EVehicleMembershipStateType2["EXPIRED"] = "EXPIRED";
  EVehicleMembershipStateType2["SUSPENDED"] = "SUSPENDED";
  EVehicleMembershipStateType2["CANCELED"] = "CANCELED";
  return EVehicleMembershipStateType2;
})({});

// src/sv-core/sha-core/vehicles/vehicle.contracts.ts
var EVehicleStatus = /* @__PURE__ */ (function(EVehicleStatus2) {
  EVehicleStatus2["ACTIVE"] = "ACTIVE";
  EVehicleStatus2["DISPOSED"] = "DISPOSED";
  EVehicleStatus2["REPATENTED"] = "REPATENTED";
  EVehicleStatus2["ORPHANED"] = "ORPHANED";
  EVehicleStatus2["STOLEN"] = "STOLEN";
  return EVehicleStatus2;
})({});

// src/sv-core/sha-core/assets/asset.enums.ts
var EAssetStatus = /* @__PURE__ */ (function(EAssetStatus2) {
  EAssetStatus2["ACTIVE"] = "ACTIVE";
  EAssetStatus2["INACTIVE"] = "INACTIVE";
  EAssetStatus2["MAINTENANCE"] = "MAINTENANCE";
  EAssetStatus2["RETIRED"] = "RETIRED";
  EAssetStatus2["DELETED"] = "DELETED";
  return EAssetStatus2;
})({});
var EAssetOnboardingType = /* @__PURE__ */ (function(EAssetOnboardingType2) {
  EAssetOnboardingType2["BY_PAIRING_CODE"] = "BY_PAIRING_CODE";
  EAssetOnboardingType2["NONE"] = "NONE";
  return EAssetOnboardingType2;
})({});
var EAssetOnboardingStatus = /* @__PURE__ */ (function(EAssetOnboardingStatus2) {
  EAssetOnboardingStatus2["PAIRING"] = "PAIRING";
  EAssetOnboardingStatus2["COMPLETED"] = "COMPLETED";
  EAssetOnboardingStatus2["NONE"] = "NONE";
  return EAssetOnboardingStatus2;
})({});

// src/sv-core/sha-core/asset_configs/asset_config.enums.ts
var EAssetConfigType = /* @__PURE__ */ (function(EAssetConfigType2) {
  EAssetConfigType2["CAMERA"] = "CAMERA";
  EAssetConfigType2["RECORDER"] = "RECORDER";
  EAssetConfigType2["TERMINAL"] = "TERMINAL";
  EAssetConfigType2["CONTROLLER"] = "CONTROLLER";
  EAssetConfigType2["READER"] = "READER";
  EAssetConfigType2["BARRIER"] = "BARRIER";
  EAssetConfigType2["ALARM_PANEL"] = "ALARM_PANEL";
  EAssetConfigType2["SIREN"] = "SIREN";
  EAssetConfigType2["SPEAKER"] = "SPEAKER";
  EAssetConfigType2["IOT_EDGE"] = "IOT_EDGE";
  EAssetConfigType2["IOT_DEVICE"] = "IOT_DEVICE";
  EAssetConfigType2["NETWORK_DEVICE"] = "NETWORK_DEVICE";
  EAssetConfigType2["STORAGE_HDD"] = "STORAGE_HDD";
  return EAssetConfigType2;
})({});
var EAssetConfigCapability = /* @__PURE__ */ (function(EAssetConfigCapability2) {
  EAssetConfigCapability2["PERSON_MANAGEMENT"] = "PERSON_MANAGEMENT";
  EAssetConfigCapability2["FACE_ENROLLMENT"] = "FACE_ENROLLMENT";
  EAssetConfigCapability2["FINGERPRINT_ENROLLMENT"] = "FINGERPRINT_ENROLLMENT";
  EAssetConfigCapability2["CARD_MANAGEMENT"] = "CARD_MANAGEMENT";
  EAssetConfigCapability2["PLATE_WHITELIST"] = "PLATE_WHITELIST";
  EAssetConfigCapability2["SNAPSHOT"] = "SNAPSHOT";
  EAssetConfigCapability2["VIDEO_STREAM"] = "VIDEO_STREAM";
  EAssetConfigCapability2["EVENT_STREAM"] = "EVENT_STREAM";
  EAssetConfigCapability2["ONBOARD_ANALYTICS"] = "ONBOARD_ANALYTICS";
  EAssetConfigCapability2["SENSOR_TELEMETRY"] = "SENSOR_TELEMETRY";
  EAssetConfigCapability2["DOOR_CONTROL"] = "DOOR_CONTROL";
  EAssetConfigCapability2["PTZ_CONTROL"] = "PTZ_CONTROL";
  EAssetConfigCapability2["ALARM_ARM_DISARM"] = "ALARM_ARM_DISARM";
  EAssetConfigCapability2["ALARM_OUTPUT_CONTROL"] = "ALARM_OUTPUT_CONTROL";
  EAssetConfigCapability2["INTERCOM_CALL"] = "INTERCOM_CALL";
  EAssetConfigCapability2["AUDIO_BROADCAST"] = "AUDIO_BROADCAST";
  EAssetConfigCapability2["RECORDING_MANAGEMENT"] = "RECORDING_MANAGEMENT";
  EAssetConfigCapability2["HEALTH_MONITORING"] = "HEALTH_MONITORING";
  return EAssetConfigCapability2;
})({});
var EAssetConfigAuthType = /* @__PURE__ */ (function(EAssetConfigAuthType2) {
  EAssetConfigAuthType2["BASIC"] = "BASIC";
  EAssetConfigAuthType2["DIGEST"] = "DIGEST";
  EAssetConfigAuthType2["TOKEN"] = "TOKEN";
  EAssetConfigAuthType2["OAUTH"] = "OAUTH";
  return EAssetConfigAuthType2;
})({});
var EAssetConfigONVIFProfile = /* @__PURE__ */ (function(EAssetConfigONVIFProfile2) {
  EAssetConfigONVIFProfile2["S"] = "S";
  EAssetConfigONVIFProfile2["T"] = "T";
  EAssetConfigONVIFProfile2["G"] = "G";
  EAssetConfigONVIFProfile2["C"] = "C";
  EAssetConfigONVIFProfile2["A"] = "A";
  EAssetConfigONVIFProfile2["D"] = "D";
  EAssetConfigONVIFProfile2["M"] = "M";
  return EAssetConfigONVIFProfile2;
})({});
var EAssetConfigRecordingMode = /* @__PURE__ */ (function(EAssetConfigRecordingMode2) {
  EAssetConfigRecordingMode2["CONTINUOUS"] = "CONTINUOUS";
  EAssetConfigRecordingMode2["EVENT"] = "EVENT";
  EAssetConfigRecordingMode2["SCHEDULE"] = "SCHEDULE";
  EAssetConfigRecordingMode2["MOTION"] = "MOTION";
  return EAssetConfigRecordingMode2;
})({});
var EAssetConfigStorageType = /* @__PURE__ */ (function(EAssetConfigStorageType2) {
  EAssetConfigStorageType2["SD"] = "SD";
  EAssetConfigStorageType2["NAS"] = "NAS";
  EAssetConfigStorageType2["NVR"] = "NVR";
  EAssetConfigStorageType2["EDGE"] = "EDGE";
  EAssetConfigStorageType2["CLOUD"] = "CLOUD";
  return EAssetConfigStorageType2;
})({});
var EAssetConfigEdgeRuntimePlatform = /* @__PURE__ */ (function(EAssetConfigEdgeRuntimePlatform2) {
  EAssetConfigEdgeRuntimePlatform2["DOCKER"] = "DOCKER";
  EAssetConfigEdgeRuntimePlatform2["K3S"] = "K3S";
  EAssetConfigEdgeRuntimePlatform2["K8S"] = "K8S";
  EAssetConfigEdgeRuntimePlatform2["NATIVE"] = "NATIVE";
  return EAssetConfigEdgeRuntimePlatform2;
})({});
var EAssetConfigVPNType = /* @__PURE__ */ (function(EAssetConfigVPNType2) {
  EAssetConfigVPNType2["WIREGUARD"] = "WIREGUARD";
  EAssetConfigVPNType2["OPENVPN"] = "OPENVPN";
  EAssetConfigVPNType2["IPSEC"] = "IPSEC";
  return EAssetConfigVPNType2;
})({});
var EAssetConfigUpdateChannel = /* @__PURE__ */ (function(EAssetConfigUpdateChannel2) {
  EAssetConfigUpdateChannel2["STABLE"] = "STABLE";
  EAssetConfigUpdateChannel2["BETA"] = "BETA";
  EAssetConfigUpdateChannel2["LTS"] = "LTS";
  return EAssetConfigUpdateChannel2;
})({});
var EAssetConfigRemoteAccessType = /* @__PURE__ */ (function(EAssetConfigRemoteAccessType2) {
  EAssetConfigRemoteAccessType2["ANYDESK"] = "ANYDESK";
  EAssetConfigRemoteAccessType2["RUSTDESK"] = "RUSTDESK";
  EAssetConfigRemoteAccessType2["TEAMVIEWER"] = "TEAMVIEWER";
  EAssetConfigRemoteAccessType2["CHROME_REMOTE_DESKTOP"] = "CHROME_REMOTE_DESKTOP";
  EAssetConfigRemoteAccessType2["SPLASHTOP"] = "SPLASHTOP";
  EAssetConfigRemoteAccessType2["REMOTEDESKTOP"] = "REMOTEDESKTOP";
  return EAssetConfigRemoteAccessType2;
})({});
var EAssetConfigOrchestratorType = /* @__PURE__ */ (function(EAssetConfigOrchestratorType2) {
  EAssetConfigOrchestratorType2["KOMODO"] = "KOMODO";
  EAssetConfigOrchestratorType2["PORTAINER"] = "PORTAINER";
  EAssetConfigOrchestratorType2["RANCHER"] = "RANCHER";
  EAssetConfigOrchestratorType2["NOMAD"] = "NOMAD";
  EAssetConfigOrchestratorType2["SWARM"] = "SWARM";
  EAssetConfigOrchestratorType2["KUBERNETES"] = "KUBERNETES";
  EAssetConfigOrchestratorType2["NONE"] = "NONE";
  return EAssetConfigOrchestratorType2;
})({});
var EAssetConfigCommunicationAdapter = /* @__PURE__ */ (function(EAssetConfigCommunicationAdapter2) {
  EAssetConfigCommunicationAdapter2["DAHUA_TERMINAL"] = "DAHUA_TERMINAL";
  EAssetConfigCommunicationAdapter2["DAHUA_LPR"] = "DAHUA_LPR";
  EAssetConfigCommunicationAdapter2["DAHUA_CAMERA"] = "DAHUA_CAMERA";
  EAssetConfigCommunicationAdapter2["HIKVISION_TERMINAL"] = "HIKVISION_TERMINAL";
  EAssetConfigCommunicationAdapter2["HIKVISION_LPR"] = "HIKVISION_LPR";
  EAssetConfigCommunicationAdapter2["HIKVISION_CAMERA"] = "HIKVISION_CAMERA";
  return EAssetConfigCommunicationAdapter2;
})({});
var EAssetConfigSipMode = /* @__PURE__ */ (function(EAssetConfigSipMode2) {
  EAssetConfigSipMode2["NEXUS_SERVER"] = "NEXUS_SERVER";
  EAssetConfigSipMode2["DEVICE_INTERNAL"] = "DEVICE_INTERNAL";
  return EAssetConfigSipMode2;
})({});
var EAssetConfigConnectivityProtocol = /* @__PURE__ */ (function(EAssetConfigConnectivityProtocol2) {
  EAssetConfigConnectivityProtocol2["ONVIF"] = "ONVIF";
  EAssetConfigConnectivityProtocol2["ISAPI"] = "ISAPI";
  EAssetConfigConnectivityProtocol2["SDK"] = "SDK";
  EAssetConfigConnectivityProtocol2["RTSP"] = "RTSP";
  EAssetConfigConnectivityProtocol2["MQTT"] = "MQTT";
  EAssetConfigConnectivityProtocol2["HTTP"] = "HTTP";
  EAssetConfigConnectivityProtocol2["HTTPS"] = "HTTPS";
  EAssetConfigConnectivityProtocol2["TCP"] = "TCP";
  EAssetConfigConnectivityProtocol2["UDP"] = "UDP";
  EAssetConfigConnectivityProtocol2["RS485"] = "RS485";
  EAssetConfigConnectivityProtocol2["RS232"] = "RS232";
  EAssetConfigConnectivityProtocol2["WIEGAND"] = "WIEGAND";
  EAssetConfigConnectivityProtocol2["OSDP"] = "OSDP";
  EAssetConfigConnectivityProtocol2["BACNET"] = "BACNET";
  EAssetConfigConnectivityProtocol2["MODBUS"] = "MODBUS";
  EAssetConfigConnectivityProtocol2["SNMP"] = "SNMP";
  EAssetConfigConnectivityProtocol2["SIP"] = "SIP";
  EAssetConfigConnectivityProtocol2["COAP"] = "COAP";
  return EAssetConfigConnectivityProtocol2;
})({});
var EAssetComponentType = /* @__PURE__ */ (function(EAssetComponentType2) {
  EAssetComponentType2["SENSOR"] = "SENSOR";
  EAssetComponentType2["ACTUATOR"] = "ACTUATOR";
  EAssetComponentType2["BUTTON"] = "BUTTON";
  EAssetComponentType2["READER"] = "READER";
  EAssetComponentType2["CAMERA"] = "CAMERA";
  EAssetComponentType2["DISPLAY"] = "DISPLAY";
  EAssetComponentType2["MODULE"] = "MODULE";
  return EAssetComponentType2;
})({});
var EAssetComponentSensorSubtype = /* @__PURE__ */ (function(EAssetComponentSensorSubtype2) {
  EAssetComponentSensorSubtype2["DOOR"] = "DOOR";
  EAssetComponentSensorSubtype2["TEMPERATURE"] = "TEMPERATURE";
  EAssetComponentSensorSubtype2["HUMIDITY"] = "HUMIDITY";
  EAssetComponentSensorSubtype2["MOTION"] = "MOTION";
  EAssetComponentSensorSubtype2["GLASS_BREAK"] = "GLASS_BREAK";
  EAssetComponentSensorSubtype2["PROXIMITY"] = "PROXIMITY";
  EAssetComponentSensorSubtype2["LIGHT"] = "LIGHT";
  EAssetComponentSensorSubtype2["GAS"] = "GAS";
  EAssetComponentSensorSubtype2["WATER_LEAK"] = "WATER_LEAK";
  EAssetComponentSensorSubtype2["AIR_QUALITY"] = "AIR_QUALITY";
  EAssetComponentSensorSubtype2["SMOKE"] = "SMOKE";
  EAssetComponentSensorSubtype2["VIBRATION"] = "VIBRATION";
  EAssetComponentSensorSubtype2["PRESSURE"] = "PRESSURE";
  EAssetComponentSensorSubtype2["LOOP"] = "LOOP";
  EAssetComponentSensorSubtype2["PHOTOCELL"] = "PHOTOCELL";
  return EAssetComponentSensorSubtype2;
})({});
var EAssetComponentActuatorSubtype = /* @__PURE__ */ (function(EAssetComponentActuatorSubtype2) {
  EAssetComponentActuatorSubtype2["RELAY"] = "RELAY";
  EAssetComponentActuatorSubtype2["LOCK"] = "LOCK";
  EAssetComponentActuatorSubtype2["BUZZER"] = "BUZZER";
  EAssetComponentActuatorSubtype2["LED"] = "LED";
  EAssetComponentActuatorSubtype2["IR"] = "IR";
  EAssetComponentActuatorSubtype2["SPEAKER"] = "SPEAKER";
  EAssetComponentActuatorSubtype2["MOTOR"] = "MOTOR";
  EAssetComponentActuatorSubtype2["DRY_CONTACT"] = "DRY_CONTACT";
  EAssetComponentActuatorSubtype2["SOLENOID"] = "SOLENOID";
  EAssetComponentActuatorSubtype2["VALVE"] = "VALVE";
  return EAssetComponentActuatorSubtype2;
})({});
var EAssetComponentButtonSubtype = /* @__PURE__ */ (function(EAssetComponentButtonSubtype2) {
  EAssetComponentButtonSubtype2["REX"] = "REX";
  EAssetComponentButtonSubtype2["PANIC"] = "PANIC";
  EAssetComponentButtonSubtype2["RESET"] = "RESET";
  EAssetComponentButtonSubtype2["EMERGENCY"] = "EMERGENCY";
  EAssetComponentButtonSubtype2["TOUCHLESS"] = "TOUCHLESS";
  EAssetComponentButtonSubtype2["FOOT"] = "FOOT";
  EAssetComponentButtonSubtype2["KEY_SWITCH"] = "KEY_SWITCH";
  return EAssetComponentButtonSubtype2;
})({});
var EAssetComponentReaderSubtype = /* @__PURE__ */ (function(EAssetComponentReaderSubtype2) {
  EAssetComponentReaderSubtype2["CARD"] = "CARD";
  EAssetComponentReaderSubtype2["FACE"] = "FACE";
  EAssetComponentReaderSubtype2["FINGERPRINT"] = "FINGERPRINT";
  EAssetComponentReaderSubtype2["PALM"] = "PALM";
  EAssetComponentReaderSubtype2["QR"] = "QR";
  EAssetComponentReaderSubtype2["BARCODE"] = "BARCODE";
  EAssetComponentReaderSubtype2["MULTI_BIOMETRIC"] = "MULTI_BIOMETRIC";
  return EAssetComponentReaderSubtype2;
})({});
var EAssetComponentCameraSubtype = /* @__PURE__ */ (function(EAssetComponentCameraSubtype2) {
  EAssetComponentCameraSubtype2["INTEGRATED"] = "INTEGRATED";
  EAssetComponentCameraSubtype2["LPR"] = "LPR";
  EAssetComponentCameraSubtype2["THERMAL"] = "THERMAL";
  EAssetComponentCameraSubtype2["FISHEYE"] = "FISHEYE";
  EAssetComponentCameraSubtype2["PTZ"] = "PTZ";
  return EAssetComponentCameraSubtype2;
})({});
var EAssetComponentDisplaySubtype = /* @__PURE__ */ (function(EAssetComponentDisplaySubtype2) {
  EAssetComponentDisplaySubtype2["SCREEN"] = "SCREEN";
  EAssetComponentDisplaySubtype2["LED"] = "LED";
  EAssetComponentDisplaySubtype2["LCD"] = "LCD";
  EAssetComponentDisplaySubtype2["OLED"] = "OLED";
  EAssetComponentDisplaySubtype2["EINK"] = "EINK";
  return EAssetComponentDisplaySubtype2;
})({});
var EAssetComponentModuleSubtype = /* @__PURE__ */ (function(EAssetComponentModuleSubtype2) {
  EAssetComponentModuleSubtype2["WIFI"] = "WIFI";
  EAssetComponentModuleSubtype2["BLUETOOTH"] = "BLUETOOTH";
  EAssetComponentModuleSubtype2["NFC"] = "NFC";
  EAssetComponentModuleSubtype2["LTE_4G"] = "LTE_4G";
  EAssetComponentModuleSubtype2["LTE_5G"] = "LTE_5G";
  EAssetComponentModuleSubtype2["LORA"] = "LORA";
  EAssetComponentModuleSubtype2["GPS"] = "GPS";
  EAssetComponentModuleSubtype2["ZIGBEE"] = "ZIGBEE";
  EAssetComponentModuleSubtype2["ZWAVE"] = "ZWAVE";
  EAssetComponentModuleSubtype2["THREAD"] = "THREAD";
  return EAssetComponentModuleSubtype2;
})({});
var EAssetComponentSensorWiring = /* @__PURE__ */ (function(EAssetComponentSensorWiring2) {
  EAssetComponentSensorWiring2["NC"] = "NC";
  EAssetComponentSensorWiring2["NA"] = "NA";
  EAssetComponentSensorWiring2["SUPERVISED"] = "SUPERVISED";
  return EAssetComponentSensorWiring2;
})({});
var EAssetComponentActuatorDefaultState = /* @__PURE__ */ (function(EAssetComponentActuatorDefaultState2) {
  EAssetComponentActuatorDefaultState2["OPEN"] = "OPEN";
  EAssetComponentActuatorDefaultState2["CLOSED"] = "CLOSED";
  return EAssetComponentActuatorDefaultState2;
})({});
var EAssetComponentActuatorDoorLockType = /* @__PURE__ */ (function(EAssetComponentActuatorDoorLockType2) {
  EAssetComponentActuatorDoorLockType2["MAGNETIC"] = "MAGNETIC";
  EAssetComponentActuatorDoorLockType2["STRIKE"] = "STRIKE";
  EAssetComponentActuatorDoorLockType2["BOLT"] = "BOLT";
  return EAssetComponentActuatorDoorLockType2;
})({});
var EAssetComponentButtonTriggerMode = /* @__PURE__ */ (function(EAssetComponentButtonTriggerMode2) {
  EAssetComponentButtonTriggerMode2["MOMENTARY"] = "MOMENTARY";
  EAssetComponentButtonTriggerMode2["TOGGLE"] = "TOGGLE";
  EAssetComponentButtonTriggerMode2["LATCHING"] = "LATCHING";
  return EAssetComponentButtonTriggerMode2;
})({});
var EAssetComponentReaderTechnology = /* @__PURE__ */ (function(EAssetComponentReaderTechnology2) {
  EAssetComponentReaderTechnology2["WIEGAND_26"] = "WIEGAND_26";
  EAssetComponentReaderTechnology2["WIEGAND_34"] = "WIEGAND_34";
  EAssetComponentReaderTechnology2["OSDP"] = "OSDP";
  EAssetComponentReaderTechnology2["BLE"] = "BLE";
  EAssetComponentReaderTechnology2["NFC"] = "NFC";
  EAssetComponentReaderTechnology2["MIFARE"] = "MIFARE";
  EAssetComponentReaderTechnology2["DESFIRE"] = "DESFIRE";
  EAssetComponentReaderTechnology2["PROXIMITY"] = "PROXIMITY";
  EAssetComponentReaderTechnology2["UHF"] = "UHF";
  EAssetComponentReaderTechnology2["HID_ICLASS"] = "HID_ICLASS";
  EAssetComponentReaderTechnology2["EM_MARINE"] = "EM_MARINE";
  return EAssetComponentReaderTechnology2;
})({});

// src/sv-core/sha-core/assets/asset.enum_meta.ts
var EAssetStatusMeta = {
  [EAssetStatus.ACTIVE]: {
    label: "Activo",
    color: "#2e9e5b",
    order: 1
  },
  [EAssetStatus.INACTIVE]: {
    label: "Inactivo",
    color: "#8a8f98",
    order: 2
  },
  [EAssetStatus.MAINTENANCE]: {
    label: "En mantenimiento",
    color: "#e6a23c",
    order: 3
  },
  [EAssetStatus.RETIRED]: {
    label: "Retirado",
    color: "#6b7280",
    order: 4
  },
  [EAssetStatus.DELETED]: {
    label: "Eliminado",
    color: "#e05555",
    order: 5
  }
};
var EAssetConfigTypeMeta = {
  [EAssetConfigType.CAMERA]: {
    label: "C\xE1mara",
    group: "Video",
    order: 1
  },
  [EAssetConfigType.RECORDER]: {
    label: "Grabador (NVR/DVR)",
    group: "Video",
    order: 2
  },
  [EAssetConfigType.TERMINAL]: {
    label: "Terminal de acceso",
    group: "Control de acceso",
    order: 3
  },
  [EAssetConfigType.CONTROLLER]: {
    label: "Controladora",
    group: "Control de acceso",
    order: 4
  },
  [EAssetConfigType.READER]: {
    label: "Lectora",
    group: "Control de acceso",
    order: 5
  },
  [EAssetConfigType.BARRIER]: {
    label: "Barrera",
    group: "Control de acceso",
    order: 6
  },
  // M42.8 (§9.91): INTERCOM eliminado — un portero es TERMINAL +
  // capability INTERCOM_CALL (migrado en campo).
  [EAssetConfigType.ALARM_PANEL]: {
    label: "Panel de alarma",
    group: "Alarma y audio",
    order: 7
  },
  [EAssetConfigType.SIREN]: {
    label: "Sirena",
    group: "Alarma y audio",
    order: 8
  },
  [EAssetConfigType.SPEAKER]: {
    label: "Altavoz",
    group: "Alarma y audio",
    order: 9
  },
  [EAssetConfigType.IOT_EDGE]: {
    label: "Edge IoT (Gateway)",
    group: "Infraestructura SGI",
    order: 10
  },
  [EAssetConfigType.IOT_DEVICE]: {
    label: "Dispositivo IoT",
    group: "Infraestructura SGI",
    order: 11
  },
  [EAssetConfigType.NETWORK_DEVICE]: {
    label: "Dispositivo de red",
    group: "Red y almacenamiento",
    order: 12
  },
  [EAssetConfigType.STORAGE_HDD]: {
    label: "Disco / Almacenamiento",
    group: "Red y almacenamiento",
    order: 13
  }
};
var EAssetConfigCapabilityMeta = {
  [EAssetConfigCapability.PERSON_MANAGEMENT]: {
    label: "Gesti\xF3n de personas",
    description: "Altas, bajas y cambios de personas (nombre, foto, vigencia) en el dispositivo",
    group: "Credenciales",
    order: 1
  },
  [EAssetConfigCapability.FACE_ENROLLMENT]: {
    label: "Enrolamiento de rostros",
    description: "El dispositivo acepta gesti\xF3n remota de rostros desde el sistema",
    group: "Credenciales",
    order: 2
  },
  [EAssetConfigCapability.FINGERPRINT_ENROLLMENT]: {
    label: "Enrolamiento de huellas",
    group: "Credenciales",
    order: 3
  },
  [EAssetConfigCapability.CARD_MANAGEMENT]: {
    label: "Gesti\xF3n de tarjetas",
    group: "Credenciales",
    order: 4
  },
  [EAssetConfigCapability.PLATE_WHITELIST]: {
    label: "Lista de patentes",
    description: "Gesti\xF3n de patentes permitidas/bloqueadas en el dispositivo",
    group: "Credenciales",
    order: 5
  },
  [EAssetConfigCapability.SNAPSHOT]: {
    label: "Snapshot",
    description: "Captura de Instant\xE1nea",
    group: "Streams",
    order: 6
  },
  [EAssetConfigCapability.VIDEO_STREAM]: {
    label: "Streaming de video",
    group: "Streams",
    order: 6
  },
  [EAssetConfigCapability.EVENT_STREAM]: {
    label: "Recepci\xF3n de eventos",
    group: "Streams",
    order: 7
  },
  [EAssetConfigCapability.ONBOARD_ANALYTICS]: {
    label: "Anal\xEDtica en el dispositivo",
    description: "Eventos enriquecidos con IA del propio equipo (lectura de patente, match facial)",
    group: "Streams",
    order: 8
  },
  [EAssetConfigCapability.SENSOR_TELEMETRY]: {
    label: "Telemetr\xEDa de sensores",
    group: "Streams",
    order: 9
  },
  [EAssetConfigCapability.DOOR_CONTROL]: {
    label: "Apertura remota",
    group: "Control",
    order: 10
  },
  [EAssetConfigCapability.PTZ_CONTROL]: {
    label: "Control PTZ",
    group: "Control",
    order: 11
  },
  [EAssetConfigCapability.ALARM_ARM_DISARM]: {
    label: "Armado/Desarmado",
    group: "Control",
    order: 12
  },
  [EAssetConfigCapability.ALARM_OUTPUT_CONTROL]: {
    label: "Control de salidas de alarma",
    group: "Control",
    order: 13
  },
  [EAssetConfigCapability.INTERCOM_CALL]: {
    label: "Llamadas / Intercom",
    group: "Control",
    order: 14
  },
  [EAssetConfigCapability.AUDIO_BROADCAST]: {
    label: "Mensajes de audio",
    group: "Control",
    order: 15
  },
  [EAssetConfigCapability.RECORDING_MANAGEMENT]: {
    label: "Gesti\xF3n de grabaciones",
    group: "Grabaci\xF3n",
    order: 16
  },
  [EAssetConfigCapability.HEALTH_MONITORING]: {
    label: "Monitoreo de salud",
    group: "Monitoreo",
    order: 17
  }
};
var EAssetConfigCommunicationAdapterMeta = {
  [EAssetConfigCommunicationAdapter.HIKVISION_TERMINAL]: {
    label: "Hikvision Terminal",
    order: 1
  },
  [EAssetConfigCommunicationAdapter.HIKVISION_LPR]: {
    label: "Hikvision LPR",
    order: 2
  },
  [EAssetConfigCommunicationAdapter.HIKVISION_CAMERA]: {
    label: "Hikvision C\xE1mara",
    order: 3
  },
  [EAssetConfigCommunicationAdapter.DAHUA_TERMINAL]: {
    label: "Dahua Terminal",
    order: 4
  },
  [EAssetConfigCommunicationAdapter.DAHUA_LPR]: {
    label: "Dahua LPR",
    order: 5
  },
  [EAssetConfigCommunicationAdapter.DAHUA_CAMERA]: {
    label: "Dahua C\xE1mara",
    order: 6
  }
};
var EAssetConfigSipModeMeta = {
  [EAssetConfigSipMode.NEXUS_SERVER]: {
    label: "Servidor SGI (edge)",
    order: 1,
    description: "El dispositivo se registra al SIP UA del edge \u2014 el nexus autoconfigura su SIP"
  },
  [EAssetConfigSipMode.DEVICE_INTERNAL]: {
    label: "Servidor interno del dispositivo",
    order: 2,
    description: "El dispositivo usa su propio SIP server (convive con VTHs f\xEDsicos) \u2014 el nexus no toca su config"
  }
};
var EAssetConfigConnectivityProtocolMeta = {
  [EAssetConfigConnectivityProtocol.ONVIF]: {
    label: "ONVIF"
  },
  [EAssetConfigConnectivityProtocol.ISAPI]: {
    label: "ISAPI"
  },
  [EAssetConfigConnectivityProtocol.SDK]: {
    label: "SDK propietario"
  },
  [EAssetConfigConnectivityProtocol.RTSP]: {
    label: "RTSP"
  },
  [EAssetConfigConnectivityProtocol.MQTT]: {
    label: "MQTT"
  },
  [EAssetConfigConnectivityProtocol.HTTP]: {
    label: "HTTP"
  },
  [EAssetConfigConnectivityProtocol.HTTPS]: {
    label: "HTTPS"
  },
  [EAssetConfigConnectivityProtocol.TCP]: {
    label: "TCP"
  },
  [EAssetConfigConnectivityProtocol.UDP]: {
    label: "UDP"
  },
  [EAssetConfigConnectivityProtocol.RS485]: {
    label: "RS-485"
  },
  [EAssetConfigConnectivityProtocol.RS232]: {
    label: "RS-232"
  },
  [EAssetConfigConnectivityProtocol.WIEGAND]: {
    label: "Wiegand"
  },
  [EAssetConfigConnectivityProtocol.OSDP]: {
    label: "OSDP"
  },
  [EAssetConfigConnectivityProtocol.BACNET]: {
    label: "BACnet"
  },
  [EAssetConfigConnectivityProtocol.MODBUS]: {
    label: "Modbus"
  },
  [EAssetConfigConnectivityProtocol.SNMP]: {
    label: "SNMP"
  },
  [EAssetConfigConnectivityProtocol.SIP]: {
    label: "SIP"
  },
  [EAssetConfigConnectivityProtocol.COAP]: {
    label: "CoAP"
  }
};
var EAssetConfigAuthTypeMeta = {
  [EAssetConfigAuthType.BASIC]: {
    label: "B\xE1sica"
  },
  [EAssetConfigAuthType.DIGEST]: {
    label: "Digest"
  },
  [EAssetConfigAuthType.TOKEN]: {
    label: "Token"
  },
  [EAssetConfigAuthType.OAUTH]: {
    label: "OAuth"
  }
};
var EAssetConfigONVIFProfileMeta = {
  [EAssetConfigONVIFProfile.S]: {
    label: "Perfil S"
  },
  [EAssetConfigONVIFProfile.T]: {
    label: "Perfil T"
  },
  [EAssetConfigONVIFProfile.G]: {
    label: "Perfil G"
  },
  [EAssetConfigONVIFProfile.C]: {
    label: "Perfil C"
  },
  [EAssetConfigONVIFProfile.A]: {
    label: "Perfil A"
  },
  [EAssetConfigONVIFProfile.D]: {
    label: "Perfil D"
  },
  [EAssetConfigONVIFProfile.M]: {
    label: "Perfil M"
  }
};
var EAssetConfigRecordingModeMeta = {
  [EAssetConfigRecordingMode.CONTINUOUS]: {
    label: "Continua"
  },
  [EAssetConfigRecordingMode.EVENT]: {
    label: "Por evento"
  },
  [EAssetConfigRecordingMode.SCHEDULE]: {
    label: "Programada"
  },
  [EAssetConfigRecordingMode.MOTION]: {
    label: "Por movimiento"
  }
};
var EAssetConfigStorageTypeMeta = {
  [EAssetConfigStorageType.SD]: {
    label: "Tarjeta SD"
  },
  [EAssetConfigStorageType.NAS]: {
    label: "NAS"
  },
  [EAssetConfigStorageType.NVR]: {
    label: "NVR"
  },
  [EAssetConfigStorageType.EDGE]: {
    label: "Edge SGI"
  },
  [EAssetConfigStorageType.CLOUD]: {
    label: "Nube"
  }
};
var EAssetConfigEdgeRuntimePlatformMeta = {
  [EAssetConfigEdgeRuntimePlatform.DOCKER]: {
    label: "Docker"
  },
  [EAssetConfigEdgeRuntimePlatform.K3S]: {
    label: "K3s"
  },
  [EAssetConfigEdgeRuntimePlatform.K8S]: {
    label: "Kubernetes (K8s)"
  },
  [EAssetConfigEdgeRuntimePlatform.NATIVE]: {
    label: "Nativo (sin contenedores)"
  }
};
var EAssetConfigVPNTypeMeta = {
  [EAssetConfigVPNType.WIREGUARD]: {
    label: "WireGuard"
  },
  [EAssetConfigVPNType.OPENVPN]: {
    label: "OpenVPN"
  },
  [EAssetConfigVPNType.IPSEC]: {
    label: "IPsec"
  }
};
var EAssetConfigUpdateChannelMeta = {
  [EAssetConfigUpdateChannel.STABLE]: {
    label: "Estable"
  },
  [EAssetConfigUpdateChannel.BETA]: {
    label: "Beta"
  },
  [EAssetConfigUpdateChannel.LTS]: {
    label: "LTS (soporte extendido)"
  }
};
var EAssetConfigRemoteAccessTypeMeta = {
  [EAssetConfigRemoteAccessType.ANYDESK]: {
    label: "AnyDesk"
  },
  [EAssetConfigRemoteAccessType.RUSTDESK]: {
    label: "RustDesk"
  },
  [EAssetConfigRemoteAccessType.TEAMVIEWER]: {
    label: "TeamViewer"
  },
  [EAssetConfigRemoteAccessType.CHROME_REMOTE_DESKTOP]: {
    label: "Chrome Remote Desktop"
  },
  [EAssetConfigRemoteAccessType.SPLASHTOP]: {
    label: "Splashtop"
  },
  [EAssetConfigRemoteAccessType.REMOTEDESKTOP]: {
    label: "Escritorio Remoto (RDP)"
  }
};
var EAssetConfigOrchestratorTypeMeta = {
  [EAssetConfigOrchestratorType.KOMODO]: {
    label: "Komodo"
  },
  [EAssetConfigOrchestratorType.PORTAINER]: {
    label: "Portainer"
  },
  [EAssetConfigOrchestratorType.RANCHER]: {
    label: "Rancher"
  },
  [EAssetConfigOrchestratorType.NOMAD]: {
    label: "Nomad"
  },
  [EAssetConfigOrchestratorType.SWARM]: {
    label: "Docker Swarm"
  },
  [EAssetConfigOrchestratorType.KUBERNETES]: {
    label: "Kubernetes"
  },
  [EAssetConfigOrchestratorType.NONE]: {
    label: "Sin orquestador"
  }
};
var EAssetComponentTypeMeta = {
  [EAssetComponentType.SENSOR]: {
    label: "Sensor",
    icon: "mdi-leak",
    order: 1
  },
  [EAssetComponentType.ACTUATOR]: {
    label: "Actuador",
    icon: "mdi-electric-switch",
    order: 2
  },
  [EAssetComponentType.BUTTON]: {
    label: "Bot\xF3n",
    icon: "mdi-gesture-tap-button",
    order: 3
  },
  [EAssetComponentType.READER]: {
    label: "Lector",
    icon: "mdi-card-account-details",
    order: 4
  },
  [EAssetComponentType.CAMERA]: {
    label: "C\xE1mara integrada",
    icon: "mdi-camera",
    order: 5
  },
  [EAssetComponentType.DISPLAY]: {
    label: "Pantalla",
    icon: "mdi-monitor",
    order: 6
  },
  [EAssetComponentType.MODULE]: {
    label: "M\xF3dulo de comunicaci\xF3n",
    icon: "mdi-wifi",
    order: 7
  }
};
var EAssetComponentSensorSubtypeMeta = {
  [EAssetComponentSensorSubtype.DOOR]: {
    label: "Puerta / Contacto"
  },
  [EAssetComponentSensorSubtype.TEMPERATURE]: {
    label: "Temperatura"
  },
  [EAssetComponentSensorSubtype.HUMIDITY]: {
    label: "Humedad"
  },
  [EAssetComponentSensorSubtype.MOTION]: {
    label: "Movimiento (PIR)"
  },
  [EAssetComponentSensorSubtype.GLASS_BREAK]: {
    label: "Rotura de vidrio"
  },
  [EAssetComponentSensorSubtype.PROXIMITY]: {
    label: "Proximidad"
  },
  [EAssetComponentSensorSubtype.LIGHT]: {
    label: "Luminosidad"
  },
  [EAssetComponentSensorSubtype.GAS]: {
    label: "Gas"
  },
  [EAssetComponentSensorSubtype.WATER_LEAK]: {
    label: "Fuga de agua"
  },
  [EAssetComponentSensorSubtype.AIR_QUALITY]: {
    label: "Calidad de aire"
  },
  [EAssetComponentSensorSubtype.SMOKE]: {
    label: "Humo"
  },
  [EAssetComponentSensorSubtype.VIBRATION]: {
    label: "Vibraci\xF3n"
  },
  [EAssetComponentSensorSubtype.PRESSURE]: {
    label: "Presi\xF3n"
  },
  [EAssetComponentSensorSubtype.LOOP]: {
    label: "Lazo inductivo"
  },
  [EAssetComponentSensorSubtype.PHOTOCELL]: {
    label: "Fotoc\xE9lula"
  }
};
var EAssetComponentActuatorSubtypeMeta = {
  [EAssetComponentActuatorSubtype.RELAY]: {
    label: "Rel\xE9"
  },
  [EAssetComponentActuatorSubtype.LOCK]: {
    label: "Cerradura"
  },
  [EAssetComponentActuatorSubtype.BUZZER]: {
    label: "Zumbador"
  },
  [EAssetComponentActuatorSubtype.LED]: {
    label: "LED"
  },
  [EAssetComponentActuatorSubtype.IR]: {
    label: "Infrarrojo"
  },
  [EAssetComponentActuatorSubtype.SPEAKER]: {
    label: "Altavoz"
  },
  [EAssetComponentActuatorSubtype.MOTOR]: {
    label: "Motor"
  },
  [EAssetComponentActuatorSubtype.DRY_CONTACT]: {
    label: "Contacto seco"
  },
  [EAssetComponentActuatorSubtype.SOLENOID]: {
    label: "Solenoide"
  },
  [EAssetComponentActuatorSubtype.VALVE]: {
    label: "V\xE1lvula"
  }
};
var EAssetComponentButtonSubtypeMeta = {
  [EAssetComponentButtonSubtype.REX]: {
    label: "Bot\xF3n de salida (REX)"
  },
  [EAssetComponentButtonSubtype.PANIC]: {
    label: "P\xE1nico"
  },
  [EAssetComponentButtonSubtype.RESET]: {
    label: "Reinicio"
  },
  [EAssetComponentButtonSubtype.EMERGENCY]: {
    label: "Emergencia"
  },
  [EAssetComponentButtonSubtype.TOUCHLESS]: {
    label: "Sin contacto"
  },
  [EAssetComponentButtonSubtype.FOOT]: {
    label: "Pedal"
  },
  [EAssetComponentButtonSubtype.KEY_SWITCH]: {
    label: "Llave"
  }
};
var EAssetComponentReaderSubtypeMeta = {
  [EAssetComponentReaderSubtype.CARD]: {
    label: "Tarjeta"
  },
  [EAssetComponentReaderSubtype.FACE]: {
    label: "Rostro"
  },
  [EAssetComponentReaderSubtype.FINGERPRINT]: {
    label: "Huella"
  },
  [EAssetComponentReaderSubtype.PALM]: {
    label: "Palma"
  },
  [EAssetComponentReaderSubtype.QR]: {
    label: "C\xF3digo QR"
  },
  [EAssetComponentReaderSubtype.BARCODE]: {
    label: "C\xF3digo de barras"
  },
  [EAssetComponentReaderSubtype.MULTI_BIOMETRIC]: {
    label: "Multi-biom\xE9trico"
  }
};
var EAssetComponentCameraSubtypeMeta = {
  [EAssetComponentCameraSubtype.INTEGRATED]: {
    label: "Integrada"
  },
  [EAssetComponentCameraSubtype.LPR]: {
    label: "LPR (patentes)"
  },
  [EAssetComponentCameraSubtype.THERMAL]: {
    label: "T\xE9rmica"
  },
  [EAssetComponentCameraSubtype.FISHEYE]: {
    label: "Ojo de pez"
  },
  [EAssetComponentCameraSubtype.PTZ]: {
    label: "PTZ"
  }
};
var EAssetComponentDisplaySubtypeMeta = {
  [EAssetComponentDisplaySubtype.SCREEN]: {
    label: "Pantalla"
  },
  [EAssetComponentDisplaySubtype.LED]: {
    label: "LED"
  },
  [EAssetComponentDisplaySubtype.LCD]: {
    label: "LCD"
  },
  [EAssetComponentDisplaySubtype.OLED]: {
    label: "OLED"
  },
  [EAssetComponentDisplaySubtype.EINK]: {
    label: "E-Ink"
  }
};
var EAssetComponentModuleSubtypeMeta = {
  [EAssetComponentModuleSubtype.WIFI]: {
    label: "WiFi"
  },
  [EAssetComponentModuleSubtype.BLUETOOTH]: {
    label: "Bluetooth"
  },
  [EAssetComponentModuleSubtype.NFC]: {
    label: "NFC"
  },
  [EAssetComponentModuleSubtype.LTE_4G]: {
    label: "4G LTE"
  },
  [EAssetComponentModuleSubtype.LTE_5G]: {
    label: "5G"
  },
  [EAssetComponentModuleSubtype.LORA]: {
    label: "LoRa"
  },
  [EAssetComponentModuleSubtype.GPS]: {
    label: "GPS"
  },
  [EAssetComponentModuleSubtype.ZIGBEE]: {
    label: "Zigbee"
  },
  [EAssetComponentModuleSubtype.ZWAVE]: {
    label: "Z-Wave"
  },
  [EAssetComponentModuleSubtype.THREAD]: {
    label: "Thread"
  }
};
var EAssetComponentSensorWiringMeta = {
  [EAssetComponentSensorWiring.NC]: {
    label: "Normal cerrado (NC)"
  },
  [EAssetComponentSensorWiring.NA]: {
    label: "Normal abierto (NA)"
  },
  [EAssetComponentSensorWiring.SUPERVISED]: {
    label: "Supervisado"
  }
};
var EAssetComponentActuatorDefaultStateMeta = {
  [EAssetComponentActuatorDefaultState.OPEN]: {
    label: "Abierto"
  },
  [EAssetComponentActuatorDefaultState.CLOSED]: {
    label: "Cerrado"
  }
};
var EAssetComponentActuatorDoorLockTypeMeta = {
  [EAssetComponentActuatorDoorLockType.MAGNETIC]: {
    label: "Magn\xE9tica"
  },
  [EAssetComponentActuatorDoorLockType.STRIKE]: {
    label: "Contrachapa (strike)"
  },
  [EAssetComponentActuatorDoorLockType.BOLT]: {
    label: "Bul\xF3n"
  }
};
var EAssetComponentButtonTriggerModeMeta = {
  [EAssetComponentButtonTriggerMode.MOMENTARY]: {
    label: "Moment\xE1neo"
  },
  [EAssetComponentButtonTriggerMode.TOGGLE]: {
    label: "Conmutable"
  },
  [EAssetComponentButtonTriggerMode.LATCHING]: {
    label: "Enclavado"
  }
};
var EAssetComponentReaderTechnologyMeta = {
  [EAssetComponentReaderTechnology.WIEGAND_26]: {
    label: "Wiegand 26"
  },
  [EAssetComponentReaderTechnology.WIEGAND_34]: {
    label: "Wiegand 34"
  },
  [EAssetComponentReaderTechnology.OSDP]: {
    label: "OSDP"
  },
  [EAssetComponentReaderTechnology.BLE]: {
    label: "Bluetooth (BLE)"
  },
  [EAssetComponentReaderTechnology.NFC]: {
    label: "NFC"
  },
  [EAssetComponentReaderTechnology.MIFARE]: {
    label: "MIFARE"
  },
  [EAssetComponentReaderTechnology.DESFIRE]: {
    label: "DESFire"
  },
  [EAssetComponentReaderTechnology.PROXIMITY]: {
    label: "Proximidad (125 kHz)"
  },
  [EAssetComponentReaderTechnology.UHF]: {
    label: "UHF"
  },
  [EAssetComponentReaderTechnology.HID_ICLASS]: {
    label: "HID iCLASS"
  },
  [EAssetComponentReaderTechnology.EM_MARINE]: {
    label: "EM-Marin"
  }
};

// src/sv-core/sha-core/assets/asset.enum_meta.utils.ts
var enumOptions = /* @__PURE__ */ __name((meta) => Object.entries(meta).map(([value, m]) => ({
  value,
  ...m
})).sort((a, b) => (a.order ?? 99) - (b.order ?? 99)), "enumOptions");
var enumLabel = /* @__PURE__ */ __name((meta, value) => {
  if (!value) return "\u2014";
  return meta[value]?.label ?? value;
}, "enumLabel");
var enumMeta = /* @__PURE__ */ __name((meta, value) => {
  if (!value) return void 0;
  return meta[value];
}, "enumMeta");
var enumGroups = /* @__PURE__ */ __name((meta) => {
  const groups = /* @__PURE__ */ new Map();
  for (const opt of enumOptions(meta)) {
    const g = opt.group ?? "";
    if (!groups.has(g)) groups.set(g, []);
    groups.get(g).push(opt);
  }
  return Array.from(groups.entries()).map(([name, options]) => ({
    name,
    options
  }));
}, "enumGroups");

// src/sv-core/sha-core/assets/asset_config.factory.ts
var emptyNetwork = /* @__PURE__ */ __name(() => ({
  name: "",
  ip_address: "",
  mac_address: "",
  gateway: "",
  subnet_mask: "",
  dns_primary: "",
  dns_secondary: "",
  vlan: 0,
  network_segment: null,
  router_asset: null,
  is_primary: false
}), "emptyNetwork");
var emptyCredentials = /* @__PURE__ */ __name(() => ({
  username: "",
  password_hash: "",
  auth_type: "BASIC"
}), "emptyCredentials");
var emptySip = /* @__PURE__ */ __name(() => ({
  enabled: false,
  mode: "NEXUS_SERVER",
  auth_id: "",
  auth_password: "",
  device_user_id: "",
  device_server_id: "",
  extension: "",
  realm: "VDP",
  auto_reboot: true
}), "emptySip");
var emptyConnectivity = /* @__PURE__ */ __name(() => ({
  protocol: "HTTP",
  communication_adapter: "NONE",
  port: 0,
  secondary_port: 0,
  credentials: emptyCredentials(),
  rtsp_url: "",
  onvif_profile: "S",
  web_port: 0,
  rs485_address: 0,
  sip_endpoint: "",
  sip: emptySip(),
  snmp_version: "V2C",
  snmp_community_hash: ""
}), "emptyConnectivity");
var emptyEdgeConnectivity = /* @__PURE__ */ __name(() => ({
  protocol: "HTTP",
  port: 0,
  ssh_port: 22,
  credentials: {
    username: "",
    password_hash: "",
    ssh_key: ""
  },
  vpn_enabled: false,
  vpn_config: {
    type: "WIREGUARD",
    endpoint: ""
  }
}), "emptyEdgeConnectivity");
var emptyFirmware = /* @__PURE__ */ __name(() => ({
  auto_update: false,
  update_channel: "STABLE"
}), "emptyFirmware");
var emptyVideoStorage = /* @__PURE__ */ __name(() => ({
  type: "SD",
  recording_mode: "CONTINUOUS",
  retention_days: 30
}), "emptyVideoStorage");
var emptyOnvifMetadata = /* @__PURE__ */ __name(() => ({
  device_service_url: "",
  media_service_url: "",
  ptz_service_url: "",
  event_service_url: "",
  analytics_service_url: ""
}), "emptyOnvifMetadata");
var emptyPtz = /* @__PURE__ */ __name(() => ({
  preset_support: false,
  tour_support: false,
  pattern_support: false,
  max_presets: 0,
  pan_speed_levels: 0,
  tilt_speed_levels: 0,
  zoom_speed_levels: 0
}), "emptyPtz");
var emptyCloudConnection = /* @__PURE__ */ __name(() => ({
  endpoint_url: "",
  api_key_hash: "",
  reconnect_interval_sec: 30,
  websocket_enabled: false,
  websocket_url: ""
}), "emptyCloudConnection");
var emptyRemoteAccess = /* @__PURE__ */ __name(() => ({
  type: "ANYDESK",
  id: "",
  password_hash: "",
  alias: "",
  is_active: false,
  last_accessed_at: null,
  last_accessed_by: null
}), "emptyRemoteAccess");
var emptyEdgeRuntime = /* @__PURE__ */ __name(() => ({
  platform: "NATIVE",
  orchestrator: {
    type: "NONE",
    server_url: "",
    api_key_hash: "",
    managed: false
  }
}), "emptyEdgeRuntime");
var standardData = /* @__PURE__ */ __name(() => ({
  network: emptyNetwork(),
  connectivity: emptyConnectivity(),
  firmware: emptyFirmware()
}), "standardData");
var createEmptyConfigData = /* @__PURE__ */ __name((configType) => {
  switch (configType) {
    case EAssetConfigType.CAMERA:
      return {
        ...standardData(),
        storage: emptyVideoStorage(),
        onvif_metadata: emptyOnvifMetadata(),
        ptz: emptyPtz()
      };
    case EAssetConfigType.IOT_EDGE:
      return {
        network_interfaces: [
          emptyNetwork()
        ],
        connectivity: emptyEdgeConnectivity(),
        cloud_connection: emptyCloudConnection(),
        remote_access: [],
        edge_runtime: emptyEdgeRuntime(),
        firmware: emptyFirmware()
      };
    default:
      return standardData();
  }
}, "createEmptyConfigData");
var createEmptyComponentData = /* @__PURE__ */ __name((type) => {
  switch (type) {
    case EAssetComponentType.SENSOR:
      return {
        wiring: "NC",
        alert_on_trigger: false,
        debounce_ms: 0,
        threshold_min: 0,
        threshold_max: 0,
        sensitivity: 0
      };
    case EAssetComponentType.ACTUATOR:
      return {
        default_state: "OPEN",
        door_open_time_sec: 0,
        door_alarm_timeout_sec: 0,
        door_lock_type: "MAGNETIC",
        power_watts: 0,
        voltage: "",
        cycle_duration_ms: 0
      };
    case EAssetComponentType.BUTTON:
      return {
        trigger_mode: "MOMENTARY",
        debounce_ms: 0
      };
    case EAssetComponentType.READER:
      return {
        technology: "WIEGAND_26",
        max_cards: 0,
        max_faces: 0,
        max_fingerprints: 0,
        anti_spoofing: false,
        mask_detection: false,
        liveness_detection: false
      };
    case EAssetComponentType.CAMERA:
      return {
        stream_url: null,
        max_fps: 0,
        has_audio: false
      };
    case EAssetComponentType.DISPLAY:
      return {
        size_inches: 0,
        touch: false,
        resolution: "",
        brightness_nits: 0
      };
    case EAssetComponentType.MODULE:
      return {
        module_protocol: "",
        firmware_version: "",
        band: ""
      };
    default:
      return {};
  }
}, "createEmptyComponentData");
var createEmptyComponent = /* @__PURE__ */ __name((type, subtype) => ({
  id: typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : `cmp_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`,
  port: "",
  name: "",
  label: "",
  description: "",
  type,
  subtype,
  data: createEmptyComponentData(type),
  enabled: true,
  order: 0,
  icon: ""
}), "createEmptyComponent");

// src/sv-core/sha-core/assets/asset_component.registry.ts
var COMPONENT_SUBTYPES = {
  [EAssetComponentType.SENSOR]: Object.values(EAssetComponentSensorSubtype),
  [EAssetComponentType.ACTUATOR]: Object.values(EAssetComponentActuatorSubtype),
  [EAssetComponentType.BUTTON]: Object.values(EAssetComponentButtonSubtype),
  [EAssetComponentType.READER]: Object.values(EAssetComponentReaderSubtype),
  [EAssetComponentType.CAMERA]: Object.values(EAssetComponentCameraSubtype),
  [EAssetComponentType.DISPLAY]: Object.values(EAssetComponentDisplaySubtype),
  [EAssetComponentType.MODULE]: Object.values(EAssetComponentModuleSubtype)
};
var COMPONENT_SUBTYPE_META = {
  [EAssetComponentType.SENSOR]: EAssetComponentSensorSubtypeMeta,
  [EAssetComponentType.ACTUATOR]: EAssetComponentActuatorSubtypeMeta,
  [EAssetComponentType.BUTTON]: EAssetComponentButtonSubtypeMeta,
  [EAssetComponentType.READER]: EAssetComponentReaderSubtypeMeta,
  [EAssetComponentType.CAMERA]: EAssetComponentCameraSubtypeMeta,
  [EAssetComponentType.DISPLAY]: EAssetComponentDisplaySubtypeMeta,
  [EAssetComponentType.MODULE]: EAssetComponentModuleSubtypeMeta
};
var componentSubtypeOptions = /* @__PURE__ */ __name((type) => {
  if (!type) return [];
  const meta = COMPONENT_SUBTYPE_META[type];
  return meta ? enumOptions(meta) : [];
}, "componentSubtypeOptions");
var isValidComponentSubtype = /* @__PURE__ */ __name((type, subtype) => (COMPONENT_SUBTYPES[type] ?? []).includes(subtype), "isValidComponentSubtype");

// src/sv-core/sha-core/asset_pairings/asset_pairing.enums.ts
var EAssetPairingStatus = /* @__PURE__ */ (function(EAssetPairingStatus2) {
  EAssetPairingStatus2["PENDING"] = "PENDING";
  EAssetPairingStatus2["USED"] = "USED";
  EAssetPairingStatus2["EXPIRED"] = "EXPIRED";
  EAssetPairingStatus2["REVOKED"] = "REVOKED";
  return EAssetPairingStatus2;
})({});

// src/sv-core/sha-core/access_policies/access_policy.enums.ts
var EAccessPolicyConditionType = /* @__PURE__ */ (function(EAccessPolicyConditionType2) {
  EAccessPolicyConditionType2["AND"] = "AND";
  EAccessPolicyConditionType2["OR"] = "OR";
  EAccessPolicyConditionType2["NOT"] = "NOT";
  EAccessPolicyConditionType2["FACTOR"] = "FACTOR";
  return EAccessPolicyConditionType2;
})({});
var EAccessPolicyConditionFactorType = /* @__PURE__ */ (function(EAccessPolicyConditionFactorType2) {
  EAccessPolicyConditionFactorType2["FACIAL"] = "FACIAL";
  EAccessPolicyConditionFactorType2["FINGERPRINT"] = "FINGERPRINT";
  EAccessPolicyConditionFactorType2["IRIS"] = "IRIS";
  EAccessPolicyConditionFactorType2["PIN"] = "PIN";
  EAccessPolicyConditionFactorType2["RFID"] = "RFID";
  EAccessPolicyConditionFactorType2["QR_CODE"] = "QR_CODE";
  EAccessPolicyConditionFactorType2["LPR"] = "LPR";
  EAccessPolicyConditionFactorType2["MANUAL"] = "MANUAL";
  return EAccessPolicyConditionFactorType2;
})({});
var EAccessPolicyConditionEntity = /* @__PURE__ */ (function(EAccessPolicyConditionEntity2) {
  EAccessPolicyConditionEntity2["USER_MEMBERSHIP"] = "USER_MEMBERSHIP";
  EAccessPolicyConditionEntity2["VEHICLE_MEMBERSHIP"] = "VEHICLE_MEMBERSHIP";
  EAccessPolicyConditionEntity2["INVITATION"] = "INVITATION";
  return EAccessPolicyConditionEntity2;
})({});
var EAccessPolicyEffect = /* @__PURE__ */ (function(EAccessPolicyEffect2) {
  EAccessPolicyEffect2["ALLOW"] = "ALLOW";
  EAccessPolicyEffect2["DENY"] = "DENY";
  return EAccessPolicyEffect2;
})({});
var EAccessPolicyScope = /* @__PURE__ */ (function(EAccessPolicyScope2) {
  EAccessPolicyScope2["SPACE"] = "SPACE";
  EAccessPolicyScope2["ORGANIZATION"] = "ORGANIZATION";
  return EAccessPolicyScope2;
})({});
var EAccessPolicyScheduleDay = /* @__PURE__ */ (function(EAccessPolicyScheduleDay2) {
  EAccessPolicyScheduleDay2["MON"] = "MON";
  EAccessPolicyScheduleDay2["TUE"] = "TUE";
  EAccessPolicyScheduleDay2["WED"] = "WED";
  EAccessPolicyScheduleDay2["THU"] = "THU";
  EAccessPolicyScheduleDay2["FRI"] = "FRI";
  EAccessPolicyScheduleDay2["SAT"] = "SAT";
  EAccessPolicyScheduleDay2["SUN"] = "SUN";
  return EAccessPolicyScheduleDay2;
})({});

// src/sv-core/sha-core/access_policies/access_policy.enum_meta.ts
var EAccessPolicyConditionTypeMeta = {
  [EAccessPolicyConditionType.AND]: {
    label: "Y (todas)",
    description: "Se cumple si TODAS las condiciones hijas se cumplen.",
    color: "#3b82f6"
  },
  [EAccessPolicyConditionType.OR]: {
    label: "O (cualquiera)",
    description: "Se cumple si AL MENOS UNA condici\xF3n hija se cumple.",
    color: "#8b5cf6"
  },
  [EAccessPolicyConditionType.NOT]: {
    label: "NO",
    description: "Invierte el resultado de su \xFAnica condici\xF3n hija.",
    color: "#ef4444"
  },
  [EAccessPolicyConditionType.FACTOR]: {
    label: "Factor",
    description: "Verificaci\xF3n de un factor de acceso concreto.",
    color: "#10b981"
  }
};
var EAccessPolicyConditionFactorTypeMeta = {
  [EAccessPolicyConditionFactorType.FACIAL]: {
    label: "Rostro",
    description: "Reconocimiento facial del usuario.",
    color: "#2563eb"
  },
  [EAccessPolicyConditionFactorType.FINGERPRINT]: {
    label: "Huella",
    description: "Huella dactilar del usuario.",
    color: "#7c3aed"
  },
  [EAccessPolicyConditionFactorType.IRIS]: {
    label: "Iris",
    description: "Reconocimiento de iris del usuario.",
    color: "#0891b2"
  },
  [EAccessPolicyConditionFactorType.PIN]: {
    label: "PIN",
    description: "C\xF3digo num\xE9rico ingresado en teclado.",
    color: "#d97706"
  },
  [EAccessPolicyConditionFactorType.RFID]: {
    label: "Tarjeta RFID",
    description: "Credencial de proximidad.",
    color: "#059669"
  },
  [EAccessPolicyConditionFactorType.QR_CODE]: {
    label: "C\xF3digo QR",
    description: "QR de invitaci\xF3n o pase temporal.",
    color: "#65a30d"
  },
  [EAccessPolicyConditionFactorType.LPR]: {
    label: "Patente (LPR)",
    description: "Lectura autom\xE1tica de patente vehicular.",
    color: "#dc2626"
  },
  [EAccessPolicyConditionFactorType.MANUAL]: {
    label: "Manual",
    description: "Acci\xF3n manual de un guardia/operador.",
    color: "#6b7280"
  }
};
var EAccessPolicyConditionEntityMeta = {
  [EAccessPolicyConditionEntity.USER_MEMBERSHIP]: {
    label: "Membres\xEDa de usuario",
    description: "Requiere una membres\xEDa de persona vigente en el space.",
    color: "#3b82f6"
  },
  [EAccessPolicyConditionEntity.VEHICLE_MEMBERSHIP]: {
    label: "Membres\xEDa de veh\xEDculo",
    description: "Requiere una membres\xEDa vehicular vigente (patente + conductor).",
    color: "#f59e0b"
  },
  [EAccessPolicyConditionEntity.INVITATION]: {
    label: "Invitaci\xF3n",
    description: "Requiere una invitaci\xF3n vigente.",
    color: "#10b981"
  }
};
var EAccessPolicyScheduleDayMeta = {
  [EAccessPolicyScheduleDay.MON]: {
    label: "Lun",
    description: "Lunes",
    color: "#3b82f6"
  },
  [EAccessPolicyScheduleDay.TUE]: {
    label: "Mar",
    description: "Martes",
    color: "#3b82f6"
  },
  [EAccessPolicyScheduleDay.WED]: {
    label: "Mi\xE9",
    description: "Mi\xE9rcoles",
    color: "#3b82f6"
  },
  [EAccessPolicyScheduleDay.THU]: {
    label: "Jue",
    description: "Jueves",
    color: "#3b82f6"
  },
  [EAccessPolicyScheduleDay.FRI]: {
    label: "Vie",
    description: "Viernes",
    color: "#3b82f6"
  },
  [EAccessPolicyScheduleDay.SAT]: {
    label: "S\xE1b",
    description: "S\xE1bado",
    color: "#f59e0b"
  },
  [EAccessPolicyScheduleDay.SUN]: {
    label: "Dom",
    description: "Domingo",
    color: "#f59e0b"
  }
};

// src/sv-core/sha-core/access_configs/access_config.enums.ts
var EAccessConfigRemoteControlAction = /* @__PURE__ */ (function(EAccessConfigRemoteControlAction2) {
  EAccessConfigRemoteControlAction2["OPEN"] = "OPEN";
  EAccessConfigRemoteControlAction2["CLOSE"] = "CLOSE";
  EAccessConfigRemoteControlAction2["PULSE"] = "PULSE";
  EAccessConfigRemoteControlAction2["LOCKDOWN"] = "LOCKDOWN";
  EAccessConfigRemoteControlAction2["UNLOCK"] = "UNLOCK";
  return EAccessConfigRemoteControlAction2;
})({});

// src/sv-core/sha-core/access_configs/access_config.enum_meta.ts
var EAccessConfigRemoteControlActionMeta = {
  [EAccessConfigRemoteControlAction.OPEN]: {
    label: "Abrir",
    description: "Abre el actuador y lo deja abierto.",
    color: "#10b981"
  },
  [EAccessConfigRemoteControlAction.CLOSE]: {
    label: "Cerrar",
    description: "Cierra el actuador y lo deja cerrado.",
    color: "#f59e0b"
  },
  [EAccessConfigRemoteControlAction.PULSE]: {
    label: "Pulso",
    description: "Acciona por un tiempo breve (abre y vuelve a cerrar solo).",
    color: "#3b82f6"
  },
  [EAccessConfigRemoteControlAction.LOCKDOWN]: {
    label: "Bloqueo",
    description: "Cierra y bloquea: nadie entra hasta levantar el bloqueo.",
    color: "#dc2626"
  },
  [EAccessConfigRemoteControlAction.UNLOCK]: {
    label: "Desbloquear",
    description: "Levanta un bloqueo activo.",
    color: "#8b5cf6"
  }
};
var EUserFacePositionMeta = {
  [EUserFacePosition.FRONT]: {
    label: "Frontal",
    description: "Rostro de frente.",
    color: "#3b82f6"
  },
  [EUserFacePosition.UP]: {
    label: "Arriba",
    description: "Rostro mirando hacia arriba.",
    color: "#8b5cf6"
  },
  [EUserFacePosition.DOWN]: {
    label: "Abajo",
    description: "Rostro mirando hacia abajo.",
    color: "#0891b2"
  },
  [EUserFacePosition.LEFT]: {
    label: "Izquierda",
    description: "Rostro perfil izquierdo.",
    color: "#f59e0b"
  },
  [EUserFacePosition.RIGHT]: {
    label: "Derecha",
    description: "Rostro perfil derecho.",
    color: "#10b981"
  }
};

// src/sv-core/sha-core/asset_status/asset_status.enums.ts
var EAssetHealthStatus = /* @__PURE__ */ (function(EAssetHealthStatus2) {
  EAssetHealthStatus2["ONLINE"] = "ONLINE";
  EAssetHealthStatus2["OFFLINE"] = "OFFLINE";
  EAssetHealthStatus2["DEGRADED"] = "DEGRADED";
  EAssetHealthStatus2["UNKNOWN"] = "UNKNOWN";
  return EAssetHealthStatus2;
})({});
var EAssetStatusSource = /* @__PURE__ */ (function(EAssetStatusSource2) {
  EAssetStatusSource2["EDGE_PROBE"] = "EDGE_PROBE";
  EAssetStatusSource2["CLOUD_HEARTBEAT"] = "CLOUD_HEARTBEAT";
  EAssetStatusSource2["CLOUD_ADMIN"] = "CLOUD_ADMIN";
  return EAssetStatusSource2;
})({});

// src/sv-core/sha-iam/users/user.contracts.ts
var EUserEmailPurpose = /* @__PURE__ */ (function(EUserEmailPurpose2) {
  EUserEmailPurpose2["NOTIFICATION"] = "NOTIFICATION";
  EUserEmailPurpose2["BILLING"] = "BILLING";
  return EUserEmailPurpose2;
})({});

// src/sv-core/sha-iam/user_memberships/user_membership.contracts.ts
var EUserMembershipStateType = /* @__PURE__ */ (function(EUserMembershipStateType2) {
  EUserMembershipStateType2["ACTIVE"] = "ACTIVE";
  EUserMembershipStateType2["PENDING"] = "PENDING";
  EUserMembershipStateType2["REJECTED"] = "REJECTED";
  EUserMembershipStateType2["BANNED"] = "BANNED";
  EUserMembershipStateType2["CANCELED"] = "CANCELED";
  return EUserMembershipStateType2;
})({});

// src/sv-core/sha-iam/identification_types/identification_type.contracts.ts
var EIdentificationTypeSysCode = /* @__PURE__ */ (function(EIdentificationTypeSysCode2) {
  EIdentificationTypeSysCode2["SYS"] = "SYS";
  EIdentificationTypeSysCode2["DNI"] = "DNI";
  EIdentificationTypeSysCode2["CUIT"] = "CUIT";
  EIdentificationTypeSysCode2["PASSPORT"] = "PASSPORT";
  EIdentificationTypeSysCode2["DRIVER_LICENCE"] = "DRIVER_LICENCE";
  EIdentificationTypeSysCode2["RUT"] = "RUT";
  EIdentificationTypeSysCode2["CPF"] = "CPF";
  EIdentificationTypeSysCode2["OTHER"] = "OTHER";
  return EIdentificationTypeSysCode2;
})({});

// src/sv-core/sha-iam/user_identification_verifications/user_identification_verification.contracts.ts
var EIdentificationVerificationMethod = /* @__PURE__ */ (function(EIdentificationVerificationMethod2) {
  EIdentificationVerificationMethod2["DOCUMENT_PHOTOS"] = "DOCUMENT_PHOTOS";
  EIdentificationVerificationMethod2["GOVERNMENT_REGISTRY"] = "GOVERNMENT_REGISTRY";
  return EIdentificationVerificationMethod2;
})({});
var EIdentificationVerificationProvider = /* @__PURE__ */ (function(EIdentificationVerificationProvider2) {
  EIdentificationVerificationProvider2["AFIP_ARCA"] = "AFIP_ARCA";
  return EIdentificationVerificationProvider2;
})({});
var EIdentificationVerificationStatus = /* @__PURE__ */ (function(EIdentificationVerificationStatus2) {
  EIdentificationVerificationStatus2["PENDING"] = "PENDING";
  EIdentificationVerificationStatus2["VERIFIED"] = "VERIFIED";
  EIdentificationVerificationStatus2["REJECTED"] = "REJECTED";
  return EIdentificationVerificationStatus2;
})({});

// src/sv-core/sha-iam/user_identity_verifications/user_identity_verification.contracts.ts
var EUserIdentityVerificationMethod = /* @__PURE__ */ (function(EUserIdentityVerificationMethod2) {
  EUserIdentityVerificationMethod2["FACE_MATCH"] = "FACE_MATCH";
  return EUserIdentityVerificationMethod2;
})({});
var EUserIdentityVerificationProvider = /* @__PURE__ */ (function(EUserIdentityVerificationProvider2) {
  EUserIdentityVerificationProvider2["INTERNAL"] = "INTERNAL";
  return EUserIdentityVerificationProvider2;
})({});
var EUserIdentityVerificationStatus = /* @__PURE__ */ (function(EUserIdentityVerificationStatus2) {
  EUserIdentityVerificationStatus2["PENDING"] = "PENDING";
  EUserIdentityVerificationStatus2["VERIFIED"] = "VERIFIED";
  EUserIdentityVerificationStatus2["REJECTED"] = "REJECTED";
  return EUserIdentityVerificationStatus2;
})({});

// src/sv-core/sha-iam/user_sessions/user_session.contracts.ts
var EUserSessionClient = /* @__PURE__ */ (function(EUserSessionClient2) {
  EUserSessionClient2["WEB_PLATFORM"] = "WEB_PLATFORM";
  EUserSessionClient2["MOBILE_ONE"] = "MOBILE_ONE";
  EUserSessionClient2["MOBILE_HUB"] = "MOBILE_HUB";
  EUserSessionClient2["API_SDK"] = "API_SDK";
  return EUserSessionClient2;
})({});
var EUserSessionRevokeReason = /* @__PURE__ */ (function(EUserSessionRevokeReason2) {
  EUserSessionRevokeReason2["LOGOUT"] = "LOGOUT";
  EUserSessionRevokeReason2["USER_REVOKED"] = "USER_REVOKED";
  EUserSessionRevokeReason2["ADMIN_REVOKED"] = "ADMIN_REVOKED";
  EUserSessionRevokeReason2["REUSE_DETECTED"] = "REUSE_DETECTED";
  return EUserSessionRevokeReason2;
})({});

// src/sv-core/sha-realtime/realtime.constants.ts
var REALTIME_NEXUS_NAMESPACE = "/nexus";
var REALTIME_FRONT_NAMESPACE = "/realtime";
var REALTIME_EVENT_MESSAGE = "rt:event";
var REALTIME_COMMAND_MESSAGE = "rt:command";
var REALTIME_INTERCOM_AUDIO_MESSAGE = "rt:intercom-audio";
var REALTIME_HEARTBEAT_MESSAGE = "rt:heartbeat";
var REALTIME_ORG_ROOM_PREFIX = "org:";
var REALTIME_SPACE_ROOM_PREFIX = "space:";
var ENexusCommand = /* @__PURE__ */ (function(ENexusCommand2) {
  ENexusCommand2["PING"] = "PING";
  ENexusCommand2["PTZ"] = "PTZ";
  ENexusCommand2["OPEN_ACCESS"] = "OPEN_ACCESS";
  ENexusCommand2["REGISTER_ACCESS"] = "REGISTER_ACCESS";
  ENexusCommand2["ACTUATOR_PULSE"] = "ACTUATOR_PULSE";
  ENexusCommand2["LIVE_VIEW"] = "LIVE_VIEW";
  ENexusCommand2["INTERCOM_HANGUP"] = "INTERCOM_HANGUP";
  ENexusCommand2["INTERCOM_ANSWER"] = "INTERCOM_ANSWER";
  return ENexusCommand2;
})({});
var ELiveViewAction = /* @__PURE__ */ (function(ELiveViewAction2) {
  ELiveViewAction2["START"] = "START";
  ELiveViewAction2["STOP"] = "STOP";
  return ELiveViewAction2;
})({});
var ELiveViewQuality = /* @__PURE__ */ (function(ELiveViewQuality2) {
  ELiveViewQuality2["LOW"] = "LOW";
  ELiveViewQuality2["HIGH"] = "HIGH";
  return ELiveViewQuality2;
})({});
var ELiveViewRejectReason = /* @__PURE__ */ (function(ELiveViewRejectReason2) {
  ELiveViewRejectReason2["BAD_PAYLOAD"] = "BAD_PAYLOAD";
  ELiveViewRejectReason2["NO_CAPABILITY"] = "NO_CAPABILITY";
  ELiveViewRejectReason2["NO_CAMERA_COMPONENT"] = "NO_CAMERA_COMPONENT";
  ELiveViewRejectReason2["NO_STREAM_URL"] = "NO_STREAM_URL";
  ELiveViewRejectReason2["VIEWER_LIMIT"] = "VIEWER_LIMIT";
  ELiveViewRejectReason2["GO2RTC_NOT_CONFIGURED"] = "GO2RTC_NOT_CONFIGURED";
  ELiveViewRejectReason2["CAMERA_UNREACHABLE"] = "CAMERA_UNREACHABLE";
  ELiveViewRejectReason2["INTERNAL"] = "INTERNAL";
  return ELiveViewRejectReason2;
})({});
var LIVE_VIEW_DEFAULT_MAX_VIEWERS_PER_CAMERA = 10;
var LIVE_VIEW_DEFAULT_MAX_VIEWERS = 32;
var ENexusCommandStatus = /* @__PURE__ */ (function(ENexusCommandStatus2) {
  ENexusCommandStatus2["ACK"] = "ACK";
  ENexusCommandStatus2["REJECTED"] = "REJECTED";
  ENexusCommandStatus2["TIMEOUT"] = "TIMEOUT";
  ENexusCommandStatus2["OFFLINE"] = "OFFLINE";
  return ENexusCommandStatus2;
})({});

// src/sv-nexus/sha-media/media.constants.ts
var ESnapshotStatus = /* @__PURE__ */ (function(ESnapshotStatus2) {
  ESnapshotStatus2["CAPTURED"] = "CAPTURED";
  ESnapshotStatus2["FAILED"] = "FAILED";
  ESnapshotStatus2["SKIPPED_DISABLED"] = "SKIPPED_DISABLED";
  return ESnapshotStatus2;
})({});
var ESnapshotSource = /* @__PURE__ */ (function(ESnapshotSource2) {
  ESnapshotSource2["NATIVE"] = "NATIVE";
  ESnapshotSource2["GO2RTC"] = "GO2RTC";
  ESnapshotSource2["EVENT_IMAGE"] = "EVENT_IMAGE";
  return ESnapshotSource2;
})({});
var EPtzCommand = /* @__PURE__ */ (function(EPtzCommand2) {
  EPtzCommand2["UP"] = "UP";
  EPtzCommand2["DOWN"] = "DOWN";
  EPtzCommand2["LEFT"] = "LEFT";
  EPtzCommand2["RIGHT"] = "RIGHT";
  EPtzCommand2["UP_LEFT"] = "UP_LEFT";
  EPtzCommand2["UP_RIGHT"] = "UP_RIGHT";
  EPtzCommand2["DOWN_LEFT"] = "DOWN_LEFT";
  EPtzCommand2["DOWN_RIGHT"] = "DOWN_RIGHT";
  EPtzCommand2["ZOOM_IN"] = "ZOOM_IN";
  EPtzCommand2["ZOOM_OUT"] = "ZOOM_OUT";
  EPtzCommand2["STOP"] = "STOP";
  EPtzCommand2["GOTO_PRESET"] = "GOTO_PRESET";
  EPtzCommand2["SET_PRESET"] = "SET_PRESET";
  EPtzCommand2["ABSOLUTE_POSITION"] = "ABSOLUTE_POSITION";
  return EPtzCommand2;
})({});
var EMediaCapabilityMirror = /* @__PURE__ */ (function(EMediaCapabilityMirror2) {
  EMediaCapabilityMirror2["SNAPSHOT"] = "SNAPSHOT";
  EMediaCapabilityMirror2["VIDEO_STREAM"] = "VIDEO_STREAM";
  EMediaCapabilityMirror2["PTZ_CONTROL"] = "PTZ_CONTROL";
  EMediaCapabilityMirror2["INTERCOM_CALL"] = "INTERCOM_CALL";
  return EMediaCapabilityMirror2;
})({});
var ENexusRealtimeEvent = /* @__PURE__ */ (function(ENexusRealtimeEvent2) {
  ENexusRealtimeEvent2["ACCESS_LOG_CREATED"] = "access.log.created";
  ENexusRealtimeEvent2["SNAPSHOT_CAPTURED"] = "media.snapshot.captured";
  ENexusRealtimeEvent2["DOOR_ALARM"] = "door.alarm";
  ENexusRealtimeEvent2["ANALYTICS_DETECTED"] = "analytics.detected";
  ENexusRealtimeEvent2["SESSION_EXPIRED"] = "access.session.expired";
  ENexusRealtimeEvent2["ASSET_HEALTH_CHANGED"] = "asset.health.changed";
  ENexusRealtimeEvent2["INTERCOM_RING"] = "intercom.ring";
  return ENexusRealtimeEvent2;
})({});

// src/sv-nexus/sha-access/access.constants.ts
var EDeviceAccessEventType = /* @__PURE__ */ (function(EDeviceAccessEventType2) {
  EDeviceAccessEventType2["FACIAL"] = "FACIAL";
  EDeviceAccessEventType2["CARD"] = "CARD";
  EDeviceAccessEventType2["FINGERPRINT"] = "FINGERPRINT";
  EDeviceAccessEventType2["PLATE"] = "PLATE";
  EDeviceAccessEventType2["EXIT_BUTTON"] = "EXIT_BUTTON";
  EDeviceAccessEventType2["MANUAL"] = "MANUAL";
  EDeviceAccessEventType2["UNKNOWN"] = "UNKNOWN";
  return EDeviceAccessEventType2;
})({});
var EDeviceDoorAction = /* @__PURE__ */ (function(EDeviceDoorAction2) {
  EDeviceDoorAction2["OPEN"] = "OPEN";
  EDeviceDoorAction2["CLOSE"] = "CLOSE";
  EDeviceDoorAction2["PULSE"] = "PULSE";
  EDeviceDoorAction2["LOCKDOWN"] = "LOCKDOWN";
  EDeviceDoorAction2["UNLOCK"] = "UNLOCK";
  return EDeviceDoorAction2;
})({});
var EAccessDecisionOutcome = /* @__PURE__ */ (function(EAccessDecisionOutcome2) {
  EAccessDecisionOutcome2["GRANT"] = "GRANT";
  EAccessDecisionOutcome2["DENY"] = "DENY";
  EAccessDecisionOutcome2["PENDING_CONFIRMATION"] = "PENDING_CONFIRMATION";
  return EAccessDecisionOutcome2;
})({});
var EDeviceRawEventType = /* @__PURE__ */ (function(EDeviceRawEventType2) {
  EDeviceRawEventType2["CREDENTIAL"] = "CREDENTIAL";
  EDeviceRawEventType2["EXIT_BUTTON"] = "EXIT_BUTTON";
  EDeviceRawEventType2["DOOR_STATUS"] = "DOOR_STATUS";
  EDeviceRawEventType2["ALARM_INPUT"] = "ALARM_INPUT";
  EDeviceRawEventType2["REMOTE_OPEN_ECHO"] = "REMOTE_OPEN_ECHO";
  EDeviceRawEventType2["OPERATOR_COMMAND"] = "OPERATOR_COMMAND";
  EDeviceRawEventType2["PLATE"] = "PLATE";
  EDeviceRawEventType2["ANALYTICS"] = "ANALYTICS";
  EDeviceRawEventType2["DOOR_FORCED"] = "DOOR_FORCED";
  EDeviceRawEventType2["DOOR_LEFT_OPEN"] = "DOOR_LEFT_OPEN";
  EDeviceRawEventType2["INTERCOM_CALL"] = "INTERCOM_CALL";
  return EDeviceRawEventType2;
})({});
var EDeviceRawEventOrigin = /* @__PURE__ */ (function(EDeviceRawEventOrigin2) {
  EDeviceRawEventOrigin2["PHYSICAL"] = "PHYSICAL";
  EDeviceRawEventOrigin2["DERIVED"] = "DERIVED";
  return EDeviceRawEventOrigin2;
})({});
var ELprEventSource = /* @__PURE__ */ (function(ELprEventSource2) {
  ELprEventSource2["STREAM"] = "STREAM";
  ELprEventSource2["WEBHOOK"] = "WEBHOOK";
  return ELprEventSource2;
})({});
var EAccessDenyReason = /* @__PURE__ */ (function(EAccessDenyReason2) {
  EAccessDenyReason2["NO_ACTIVE_MEMBERSHIP"] = "NO_ACTIVE_MEMBERSHIP";
  EAccessDenyReason2["MEMBERSHIP_NOT_YET_VALID"] = "MEMBERSHIP_NOT_YET_VALID";
  EAccessDenyReason2["MEMBERSHIP_EXPIRED"] = "MEMBERSHIP_EXPIRED";
  EAccessDenyReason2["NO_POLICY_FOR_SPACE"] = "NO_POLICY_FOR_SPACE";
  EAccessDenyReason2["POLICY_CONDITION_FAILED"] = "POLICY_CONDITION_FAILED";
  EAccessDenyReason2["POLICY_SCHEDULE_OUTSIDE"] = "POLICY_SCHEDULE_OUTSIDE";
  EAccessDenyReason2["NO_TARGETS_CONFIGURED"] = "NO_TARGETS_CONFIGURED";
  EAccessDenyReason2["ACTUATION_FAILED"] = "ACTUATION_FAILED";
  EAccessDenyReason2["EGRESS_DISABLED"] = "EGRESS_DISABLED";
  EAccessDenyReason2["VEHICLE_STOLEN"] = "VEHICLE_STOLEN";
  EAccessDenyReason2["SESSION_PENDING"] = "SESSION_PENDING";
  return EAccessDenyReason2;
})({});
var EAccessSessionState = /* @__PURE__ */ (function(EAccessSessionState2) {
  EAccessSessionState2["OPEN"] = "OPEN";
  EAccessSessionState2["COMPLETED"] = "COMPLETED";
  EAccessSessionState2["EXPIRED"] = "EXPIRED";
  return EAccessSessionState2;
})({});
var EDoorAlarmType = /* @__PURE__ */ (function(EDoorAlarmType2) {
  EDoorAlarmType2["FORCED_OPEN"] = "FORCED_OPEN";
  EDoorAlarmType2["LEFT_OPEN"] = "LEFT_OPEN";
  return EDoorAlarmType2;
})({});
var EDoorOpenCause = /* @__PURE__ */ (function(EDoorOpenCause2) {
  EDoorOpenCause2["GRANT_SOURCE"] = "GRANT_SOURCE";
  EDoorOpenCause2["GRANT_TARGET"] = "GRANT_TARGET";
  EDoorOpenCause2["EXIT_BUTTON"] = "EXIT_BUTTON";
  return EDoorOpenCause2;
})({});

// src/sv-core/sha-realtime/event-priority.ts
var EEventPriority = /* @__PURE__ */ (function(EEventPriority2) {
  EEventPriority2["CRITICAL"] = "CRITICAL";
  EEventPriority2["HIGH"] = "HIGH";
  EEventPriority2["MEDIUM"] = "MEDIUM";
  EEventPriority2["LOW"] = "LOW";
  EEventPriority2["INFO"] = "INFO";
  return EEventPriority2;
})({});
function resolveEventPriority(event, payload) {
  switch (event) {
    case ENexusRealtimeEvent.DOOR_ALARM:
      return payload?.alarm_type === EDoorAlarmType.FORCED_OPEN ? "CRITICAL" : "HIGH";
    // LEFT_OPEN
    // M42.4 (decision del usuario): el ring del portero exige accion
    // inmediata del operador (atender/rechazar) — mismo nivel que
    // puerta forzada: tarjeta pulsando + sonido de ring en loop.
    case ENexusRealtimeEvent.INTERCOM_RING:
      return "CRITICAL";
    case ENexusRealtimeEvent.ANALYTICS_DETECTED:
      return "INFO";
    case ENexusRealtimeEvent.SESSION_EXPIRED:
      return "MEDIUM";
    case ENexusRealtimeEvent.ACCESS_LOG_CREATED:
      return payload?.outcome === EAccessDecisionOutcome.DENY ? "MEDIUM" : "INFO";
    case ENexusRealtimeEvent.SNAPSHOT_CAPTURED:
      return payload?.status === ESnapshotStatus.FAILED ? "LOW" : "INFO";
    case ENexusRealtimeEvent.ASSET_HEALTH_CHANGED:
      switch (payload?.status) {
        case EAssetHealthStatus.OFFLINE:
          return "HIGH";
        case EAssetHealthStatus.DEGRADED:
          return "MEDIUM";
        case EAssetHealthStatus.UNKNOWN:
          return "LOW";
        default:
          return "INFO";
      }
    default:
      return "INFO";
  }
}
__name(resolveEventPriority, "resolveEventPriority");

// src/sv-nexus/sha-sync/sync.constants.ts
var ENexusPairingStatusMirror = /* @__PURE__ */ (function(ENexusPairingStatusMirror2) {
  ENexusPairingStatusMirror2["COMPLETED"] = "COMPLETED";
  return ENexusPairingStatusMirror2;
})({});
var PROFILE_CODE_SPACE_ACCESS = "space:access";
var PROFILE_CODE_VEHICLE_ACCESS = "vehicle:access";
var ESyncCollection = /* @__PURE__ */ (function(ESyncCollection2) {
  ESyncCollection2["ACCESS_CONFIGS"] = "access_configs";
  ESyncCollection2["ACCESS_POLICIES"] = "access_policies";
  ESyncCollection2["ASSETS"] = "assets";
  ESyncCollection2["ASSET_CONFIGS"] = "asset_configs";
  ESyncCollection2["USER_MEMBERSHIPS"] = "user_memberships";
  ESyncCollection2["VEHICLE_MEMBERSHIPS"] = "vehicle_memberships";
  ESyncCollection2["USERS"] = "users";
  ESyncCollection2["VEHICLES"] = "vehicles";
  ESyncCollection2["USER_FACES"] = "user_faces";
  ESyncCollection2["MEDIAS"] = "medias";
  return ESyncCollection2;
})({});
var SYNC_COLLECTION_TO_MONGO = {
  ["access_configs"]: "access_configs",
  ["access_policies"]: "access_policies",
  ["assets"]: "assets",
  ["asset_configs"]: "asset_configs",
  ["user_memberships"]: "user_memberships",
  ["vehicle_memberships"]: "vehicle_memberships",
  ["users"]: "users",
  ["vehicles"]: "vehicles",
  ["user_faces"]: "user_faces",
  ["medias"]: "medias"
};
var ESyncMode = /* @__PURE__ */ (function(ESyncMode2) {
  ESyncMode2["SNAPSHOT"] = "SNAPSHOT";
  ESyncMode2["INCREMENTAL"] = "INCREMENTAL";
  return ESyncMode2;
})({});
var SYNC_COLLECTION_MODES = {
  ["access_configs"]: "SNAPSHOT",
  ["access_policies"]: "SNAPSHOT",
  ["assets"]: "INCREMENTAL",
  ["asset_configs"]: "INCREMENTAL",
  ["user_memberships"]: "INCREMENTAL",
  ["vehicle_memberships"]: "INCREMENTAL",
  ["users"]: "INCREMENTAL",
  ["vehicles"]: "INCREMENTAL",
  ["user_faces"]: "INCREMENTAL",
  ["medias"]: "INCREMENTAL"
};
var ESyncEntryStatus = /* @__PURE__ */ (function(ESyncEntryStatus2) {
  ESyncEntryStatus2["IDLE"] = "IDLE";
  ESyncEntryStatus2["RUNNING"] = "RUNNING";
  ESyncEntryStatus2["ERROR"] = "ERROR";
  return ESyncEntryStatus2;
})({});
var ESyncTrigger = /* @__PURE__ */ (function(ESyncTrigger2) {
  ESyncTrigger2["BOOT"] = "boot";
  ESyncTrigger2["TIMER"] = "timer";
  ESyncTrigger2["MANUAL"] = "manual";
  return ESyncTrigger2;
})({});
var EReconcileReason = /* @__PURE__ */ (function(EReconcileReason2) {
  EReconcileReason2["COUNT_DROP"] = "COUNT_DROP";
  EReconcileReason2["PERIODIC"] = "PERIODIC";
  EReconcileReason2["MANUAL"] = "MANUAL";
  return EReconcileReason2;
})({});
var EMediaFileStatus = /* @__PURE__ */ (function(EMediaFileStatus2) {
  EMediaFileStatus2["PENDING"] = "PENDING";
  EMediaFileStatus2["DOWNLOADING"] = "DOWNLOADING";
  EMediaFileStatus2["READY"] = "READY";
  EMediaFileStatus2["ERROR"] = "ERROR";
  return EMediaFileStatus2;
})({});
var EIngestRejectReason = /* @__PURE__ */ (function(EIngestRejectReason2) {
  EIngestRejectReason2["OUT_OF_SCOPE"] = "OUT_OF_SCOPE";
  EIngestRejectReason2["INVALID_FK"] = "INVALID_FK";
  EIngestRejectReason2["VALIDATION"] = "VALIDATION";
  EIngestRejectReason2["MEDIA_NOT_PENDING"] = "MEDIA_NOT_PENDING";
  EIngestRejectReason2["CHECKSUM_MISMATCH"] = "CHECKSUM_MISMATCH";
  return EIngestRejectReason2;
})({});
var EUploadLocalError = /* @__PURE__ */ (function(EUploadLocalError2) {
  EUploadLocalError2["FILE_MISSING"] = "FILE_MISSING";
  EUploadLocalError2["READ_ERROR"] = "READ_ERROR";
  EUploadLocalError2["TRANSFORM_ERROR"] = "TRANSFORM_ERROR";
  return EUploadLocalError2;
})({});
var EOrphanEntityType = /* @__PURE__ */ (function(EOrphanEntityType2) {
  EOrphanEntityType2["USER"] = "USER";
  EOrphanEntityType2["VEHICLE"] = "VEHICLE";
  return EOrphanEntityType2;
})({});
var SYNC_REFERENTIAL_COLLECTIONS = [
  "users",
  "vehicles",
  "user_faces",
  "medias"
];

// src/sv-nexus/sha-asset-management/asset-management.constants.ts
var EDeviceEntityType = /* @__PURE__ */ (function(EDeviceEntityType2) {
  EDeviceEntityType2["USER"] = "USER";
  EDeviceEntityType2["FACESET"] = "FACESET";
  EDeviceEntityType2["PLATE"] = "PLATE";
  return EDeviceEntityType2;
})({});
var EAssetSyncStatus = /* @__PURE__ */ (function(EAssetSyncStatus2) {
  EAssetSyncStatus2["PENDING"] = "PENDING";
  EAssetSyncStatus2["SYNCING"] = "SYNCING";
  EAssetSyncStatus2["SYNCED"] = "SYNCED";
  EAssetSyncStatus2["ERROR"] = "ERROR";
  EAssetSyncStatus2["REMOVING"] = "REMOVING";
  return EAssetSyncStatus2;
})({});
var ESyncPlanOperation = /* @__PURE__ */ (function(ESyncPlanOperation2) {
  ESyncPlanOperation2["CREATE"] = "CREATE";
  ESyncPlanOperation2["UPDATE"] = "UPDATE";
  ESyncPlanOperation2["DELETE"] = "DELETE";
  ESyncPlanOperation2["RESURRECT"] = "RESURRECT";
  ESyncPlanOperation2["NONE"] = "NONE";
  return ESyncPlanOperation2;
})({});
var EAssetPlanSkipReason = /* @__PURE__ */ (function(EAssetPlanSkipReason2) {
  EAssetPlanSkipReason2["SIN_ASSET_CONFIG"] = "sin asset_config";
  EAssetPlanSkipReason2["ASSET_SIN_SPACE"] = "asset sin space asignado";
  return EAssetPlanSkipReason2;
})({});
var EBlockedEntityReason = /* @__PURE__ */ (function(EBlockedEntityReason2) {
  EBlockedEntityReason2["WAITING_MEDIA"] = "WAITING_MEDIA";
  return EBlockedEntityReason2;
})({});
var EPlanRunReason = /* @__PURE__ */ (function(EPlanRunReason2) {
  EPlanRunReason2["MANUAL"] = "manual";
  EPlanRunReason2["CYCLE"] = "cycle";
  EPlanRunReason2["MEDIA_READY"] = "media.ready";
  EPlanRunReason2["RECONCILE_REMOVED"] = "reconcile.removed";
  return EPlanRunReason2;
})({});
var EDeviceReconcileReason = /* @__PURE__ */ (function(EDeviceReconcileReason2) {
  EDeviceReconcileReason2["PERIODIC"] = "PERIODIC";
  EDeviceReconcileReason2["MANUAL"] = "MANUAL";
  return EDeviceReconcileReason2;
})({});
var EForeignEntityPolicy = /* @__PURE__ */ (function(EForeignEntityPolicy2) {
  EForeignEntityPolicy2["DELETE"] = "DELETE";
  EForeignEntityPolicy2["IGNORE"] = "IGNORE";
  EForeignEntityPolicy2["REPORT"] = "REPORT";
  return EForeignEntityPolicy2;
})({});
var FOREIGN_ENTITY_POLICY = "DELETE";
export {
  COMPONENT_SUBTYPES,
  COMPONENT_SUBTYPE_META,
  EAccessConfigRemoteControlAction,
  EAccessConfigRemoteControlActionMeta,
  EAccessDecisionOutcome,
  EAccessDenyReason,
  EAccessPolicyConditionEntity,
  EAccessPolicyConditionEntityMeta,
  EAccessPolicyConditionFactorType,
  EAccessPolicyConditionFactorTypeMeta,
  EAccessPolicyConditionType,
  EAccessPolicyConditionTypeMeta,
  EAccessPolicyEffect,
  EAccessPolicyScheduleDay,
  EAccessPolicyScheduleDayMeta,
  EAccessPolicyScope,
  EAccessSessionState,
  EAssetComponentActuatorDefaultState,
  EAssetComponentActuatorDefaultStateMeta,
  EAssetComponentActuatorDoorLockType,
  EAssetComponentActuatorDoorLockTypeMeta,
  EAssetComponentActuatorSubtype,
  EAssetComponentActuatorSubtypeMeta,
  EAssetComponentButtonSubtype,
  EAssetComponentButtonSubtypeMeta,
  EAssetComponentButtonTriggerMode,
  EAssetComponentButtonTriggerModeMeta,
  EAssetComponentCameraSubtype,
  EAssetComponentCameraSubtypeMeta,
  EAssetComponentDisplaySubtype,
  EAssetComponentDisplaySubtypeMeta,
  EAssetComponentModuleSubtype,
  EAssetComponentModuleSubtypeMeta,
  EAssetComponentReaderSubtype,
  EAssetComponentReaderSubtypeMeta,
  EAssetComponentReaderTechnology,
  EAssetComponentReaderTechnologyMeta,
  EAssetComponentSensorSubtype,
  EAssetComponentSensorSubtypeMeta,
  EAssetComponentSensorWiring,
  EAssetComponentSensorWiringMeta,
  EAssetComponentType,
  EAssetComponentTypeMeta,
  EAssetConfigAuthType,
  EAssetConfigAuthTypeMeta,
  EAssetConfigCapability,
  EAssetConfigCapabilityMeta,
  EAssetConfigCommunicationAdapter,
  EAssetConfigCommunicationAdapterMeta,
  EAssetConfigConnectivityProtocol,
  EAssetConfigConnectivityProtocolMeta,
  EAssetConfigEdgeRuntimePlatform,
  EAssetConfigEdgeRuntimePlatformMeta,
  EAssetConfigONVIFProfile,
  EAssetConfigONVIFProfileMeta,
  EAssetConfigOrchestratorType,
  EAssetConfigOrchestratorTypeMeta,
  EAssetConfigRecordingMode,
  EAssetConfigRecordingModeMeta,
  EAssetConfigRemoteAccessType,
  EAssetConfigRemoteAccessTypeMeta,
  EAssetConfigSipMode,
  EAssetConfigSipModeMeta,
  EAssetConfigStorageType,
  EAssetConfigStorageTypeMeta,
  EAssetConfigType,
  EAssetConfigTypeMeta,
  EAssetConfigUpdateChannel,
  EAssetConfigUpdateChannelMeta,
  EAssetConfigVPNType,
  EAssetConfigVPNTypeMeta,
  EAssetHealthStatus,
  EAssetOnboardingStatus,
  EAssetOnboardingType,
  EAssetPairingStatus,
  EAssetPlanSkipReason,
  EAssetStatus,
  EAssetStatusMeta,
  EAssetStatusSource,
  EAssetSyncStatus,
  EBlockedEntityReason,
  EDeviceAccessEventType,
  EDeviceDoorAction,
  EDeviceEntityType,
  EDeviceRawEventOrigin,
  EDeviceRawEventType,
  EDeviceReconcileReason,
  EDoorAlarmType,
  EDoorOpenCause,
  EEventPriority,
  EForeignEntityPolicy,
  EIdentificationTypeSysCode,
  EIdentificationVerificationMethod,
  EIdentificationVerificationProvider,
  EIdentificationVerificationStatus,
  EIngestRejectReason,
  EInvitationStatus,
  EInvitationType,
  ELiveViewAction,
  ELiveViewQuality,
  ELiveViewRejectReason,
  ELprEventSource,
  EMediaCapabilityMirror,
  EMediaFileStatus,
  EMediaFolder,
  EMediaStatus,
  ENexusCommand,
  ENexusCommandStatus,
  ENexusPairingStatusMirror,
  ENexusRealtimeEvent,
  EOrphanEntityType,
  EPlanRunReason,
  EPtzCommand,
  EReconcileReason,
  ESnapshotSource,
  ESnapshotStatus,
  ESyncCollection,
  ESyncEntryStatus,
  ESyncMode,
  ESyncPlanOperation,
  ESyncTrigger,
  EUploadLocalError,
  EUserEmailPurpose,
  EUserFacePosition,
  EUserFacePositionMeta,
  EUserFaceStatus,
  EUserIdentityVerificationMethod,
  EUserIdentityVerificationProvider,
  EUserIdentityVerificationStatus,
  EUserMembershipStateType,
  EUserSessionClient,
  EUserSessionRevokeReason,
  EVehicleMembershipStateType,
  EVehicleStatus,
  FOREIGN_ENTITY_POLICY,
  IInvitationMetadataEnrollmentType,
  LIVE_VIEW_DEFAULT_MAX_VIEWERS,
  LIVE_VIEW_DEFAULT_MAX_VIEWERS_PER_CAMERA,
  PROFILE_CODE_SPACE_ACCESS,
  PROFILE_CODE_VEHICLE_ACCESS,
  REALTIME_COMMAND_MESSAGE,
  REALTIME_EVENT_MESSAGE,
  REALTIME_FRONT_NAMESPACE,
  REALTIME_HEARTBEAT_MESSAGE,
  REALTIME_INTERCOM_AUDIO_MESSAGE,
  REALTIME_NEXUS_NAMESPACE,
  REALTIME_ORG_ROOM_PREFIX,
  REALTIME_SPACE_ROOM_PREFIX,
  SYNC_COLLECTION_MODES,
  SYNC_COLLECTION_TO_MONGO,
  SYNC_REFERENTIAL_COLLECTIONS,
  componentSubtypeOptions,
  createEmptyComponent,
  createEmptyComponentData,
  createEmptyConfigData,
  emptyCloudConnection,
  emptyConnectivity,
  emptyCredentials,
  emptyEdgeConnectivity,
  emptyEdgeRuntime,
  emptyFirmware,
  emptyNetwork,
  emptyOnvifMetadata,
  emptyPtz,
  emptyRemoteAccess,
  emptySip,
  emptyVideoStorage,
  enumGroups,
  enumLabel,
  enumMeta,
  enumOptions,
  isValidComponentSubtype,
  resolveEventPriority
};
